export const siteData = {
  "generatedAt": "2026-06-27T17:46:11.901Z",
  "contact": {
    "email": "info@slateenclave.com",
    "phone": "(410) 989-1102",
    "address": [
      "201 International Circle, Suite 230",
      "Hunt Valley, MD 21030"
    ]
  },
  "pages": [
    {
      "id": 1604,
      "type": "page",
      "title": "Latest Posts",
      "path": "/latest-posts",
      "slug": "latest-posts",
      "parent": 0,
      "date": "July 18, 2023",
      "description": "The Top Metrics to Track in Cybersecurity The New CMMC Controls for Security Awareness and Training The Benefits of Hiring a Virtual CISO How Password Managers Help ",
      "hero": "/assets/slateheaderimage.png",
      "images": [],
      "blocks": [
        {
          "type": "list",
          "items": [
            "The Top Metrics to Track in Cybersecurity",
            "The New CMMC Controls for Security Awareness and Training",
            "The Benefits of Hiring a Virtual CISO",
            "How Password Managers Help Secure Your Information Online",
            "10 Ways to Secure Your Remote Workforce"
          ]
        }
      ]
    },
    {
      "id": 1108,
      "type": "page",
      "title": "CMMC/DFARS",
      "path": "/solutions/cmmc-dfars",
      "slug": "cmmc-dfars",
      "parent": 10,
      "date": "June 8, 2021",
      "description": "Slate is known for providing security solutions for Federal Agencies—including implementing comprehensive security programs for",
      "hero": "/assets/2.png",
      "images": [
        "/assets/2.png",
        "/assets/INSCOM_SEAL-3.png",
        "/assets/Intelligence-Community-seal-2.png",
        "/assets/Department-of-Defense-seal-2.png",
        "/assets/Seal_of_the_United_States_Federal_Aviation_Administration.png"
      ],
      "blocks": [
        {
          "type": "paragraph",
          "text": "Slate is known for providing security solutions for Federal Agencies—including implementing comprehensive security programs for maximum security organizations and U.S. intelligence agencies. Our team works closely with federal government contractors to help them prepare for the upcoming Cybersecurity Maturity Model Certification (CMMC) standards and comply with the required Defense Federal Acquisition Regulation Supplement (DFARS) cybersecurity regulations."
        },
        {
          "type": "paragraph",
          "text": "Our team also provides DFARS Gap Assessments. Our gap assessments help DoD contractors meet the Maryland Defense Cybersecurity Assistance Program’s (DCAP) standards, so they can receive valuable grant money and resources—and become one step closer to being prepared for the CMMC."
        },
        {
          "type": "paragraph",
          "text": "Slate is an approved Registered Provider Organization (RPO) within the CMMC Marketplace. This means we completed all the requirements set by the CMMC-AB Code of Professional Conduct and have been vetted to help organizations prepare for the CMMC. We are a vendor of the MDMEP and are in the process of becoming a certified CMMC Third-Party Assessor Organization (C3PAO). Our team is comprised of highly skilled, recognized, and respected professionals in the security industry. We maintain standard certifications, DoD 8570 compliance, the appropriate clearances, and continuing education to ensure the highest security of your organization."
        }
      ]
    },
    {
      "id": 500,
      "type": "page",
      "title": "Contact Us",
      "path": "/contact-us",
      "slug": "contact-us",
      "parent": 0,
      "date": "September 6, 2018",
      "description": "Enhance your security posture today with Slate Enclave. Contact us and one of our representatives will discuss the needs of your organization.",
      "hero": "/assets/iStock-649495828-1-e1536590990154.jpg",
      "images": [
        "/assets/iStock-649495828-1-e1536590990154.jpg"
      ],
      "blocks": [
        {
          "type": "list",
          "items": [
            "Name First Last",
            "Company",
            "Email",
            "Phone",
            "Message"
          ]
        },
        {
          "type": "heading",
          "text": "Slate Enclave"
        },
        {
          "type": "paragraph",
          "text": "201 International Circle, Suite 230 Hunt Valley MD 21030"
        },
        {
          "type": "paragraph",
          "text": "info@slateenclave.com (410) 989-1102"
        }
      ]
    },
    {
      "id": 205,
      "type": "page",
      "title": "Community",
      "path": "/community",
      "slug": "community",
      "parent": 0,
      "date": "July 22, 2018",
      "description": "Slate is a proud supporter of American Cancer Society Linda’s Legacy Homeless Drive St.",
      "hero": "/assets/Untitled-design-8.png",
      "images": [
        "/assets/Untitled-design-8.png",
        "/assets/iStock-886646974.jpg",
        "/assets/iStock-884301598.jpg"
      ],
      "blocks": [
        {
          "type": "heading",
          "text": "Slate is a proud supporter of"
        },
        {
          "type": "paragraph",
          "text": "American Cancer Society"
        },
        {
          "type": "paragraph",
          "text": "Linda’s Legacy Homeless Drive"
        },
        {
          "type": "paragraph",
          "text": "St. Demetrios Greek Orthodox Church"
        },
        {
          "type": "heading",
          "text": "Mentorship Program"
        },
        {
          "type": "paragraph",
          "text": "Slate proudly mentors highly motivated students in Eastern Technical High School’s Maker Space Program . This program gives the opportunity to apply creative thinking skills to challenging problems while using a wide variety of technology. The students then gain an understanding on how to apply these skills in a workplace."
        }
      ]
    },
    {
      "id": 203,
      "type": "page",
      "title": "Private Schools",
      "path": "/industries/education",
      "slug": "education",
      "parent": 199,
      "date": "July 22, 2018",
      "description": "Slate has extensive experience helping private institutions implement security systems and programs to protect.",
      "hero": "/assets/4.png",
      "images": [
        "/assets/4.png"
      ],
      "blocks": [
        {
          "type": "paragraph",
          "text": "Slate has extensive experience helping private institutions implement security systems and programs to protect Personally Identifiable Information (PII) , financial information, and Protected Health Information (PHI) involved with possible medical staff. We understand how detrimental it can be for the school if this Protected Sensitive Data were to be leaked, stolen, or even sold."
        },
        {
          "type": "paragraph",
          "text": "Our team knows that in the education industry, security is more than just a technical issue—it is a cultural issue that needs to change. We ensure buy-in from senior leadership by collaborating to create a roadmap that determines what you need to accomplish to achieve a secure information system. Then, our team works with each employee to demonstrate the importance of implementing security controls in their processes, without losing the ability to perform their jobs at a high level. The framework that Slate has developed can help your institution develop a program that will address both aspects, while securing your information system."
        }
      ]
    },
    {
      "id": 202,
      "type": "page",
      "title": "Legal",
      "path": "/industries/legal",
      "slug": "legal",
      "parent": 199,
      "date": "July 22, 2018",
      "description": "Slate has assisted law firms in providing the appropriate level of security controls without disrupting the flow of their business processes. We can assist with unde",
      "hero": "/assets/5.png",
      "images": [
        "/assets/5.png"
      ],
      "blocks": [
        {
          "type": "paragraph",
          "text": "Slate understands that law firms are responsible for showing due care in implementing the appropriate security controls to protect their clients’ data. We also know that you need security systems and programs that are both high-quality and reasonable to implement—especially with attorneys and administrative staff working remotely and using personal devices. Slate develops custom security solutions that lower and mitigate the risk associated with data loss, without disrupting the flow of your business."
        },
        {
          "type": "paragraph",
          "text": "Our team determines what gaps exist within your security system and how we can work together to close them. We work with you to develop a roadmap specifically to secure your clients’ data, including any personally identifiable information (PII), that is contained within your information system."
        }
      ]
    },
    {
      "id": 201,
      "type": "page",
      "title": "Healthcare",
      "path": "/industries/healthcare",
      "slug": "healthcare",
      "parent": 199,
      "date": "July 22, 2018",
      "description": "Slate helps organizations develop and implement a roadmap to achieve compliance in the healthcare industry.",
      "hero": "/assets/3.png",
      "images": [
        "/assets/3.png"
      ],
      "blocks": [
        {
          "type": "paragraph",
          "text": "Slate helps organizations develop and implement a roadmap to achieve compliance in the healthcare industry. We have a clear understanding of how to navigate the regulatory requirements when dealing with HIPAA/HITECH and how to deploy the appropriate controls without degrading the business processes. Our team works with each business unit to determine what state-mandated compliance controls need to be in place, while putting in place the building blocks to assure a smooth transition for future growth—all while implementing the proper security controls."
        },
        {
          "type": "paragraph",
          "text": "We know how daunting the task of meeting the proper security controls can be as your organization tries to evaluate each of the HIPAA/HITECH regulatory requirements. With an increase in regulatory requirements pertaining to the Health Insurance Portability and Accountability Act (HIPAA) when dealing with Protected Health Information (PHI) , healthcare organizations need to find ways to mitigate or lower the risks involved with PHI being leaked, sold, or stolen so they do not find that they are publicly disclosing a breach due to their states breach notification rules. The last thing your organization needs is a violation that damages your profits and reputation. Our team understands that this is a delicate and incredibly important process. We can help implement the right programs and measures to protect your healthcare organization."
        }
      ]
    },
    {
      "id": 200,
      "type": "page",
      "title": "Government",
      "path": "/industries/government",
      "slug": "government",
      "parent": 199,
      "date": "July 22, 2018",
      "description": "Slate is known for being on the front line of providing top-notch security services for government",
      "hero": "/assets/2.png",
      "images": [
        "/assets/2.png",
        "/assets/INSCOM_SEAL-3.png",
        "/assets/Intelligence-Community-seal-2.png",
        "/assets/Department-of-Defense-seal-2.png",
        "/assets/Seal_of_the_United_States_Federal_Aviation_Administration.png"
      ],
      "blocks": [
        {
          "type": "paragraph",
          "text": "Slate is known for being on the front line of providing top-notch security services for government and U.S. intelligence agencies. Our team understands how important it is for government organizations to maintain high-level security postures, which is why we create advanced custom security solutions and programs to protect and secure their specific systems."
        },
        {
          "type": "paragraph",
          "text": "Our government services include Risk Management Framework (RMF), Assessment & Authorization (A&A), System Security Plans (SSP), Vulnerability Assessments, and Penetration Tests . Our experienced team understands the difficulties involved with traversing the A&A process while maintaining RMF. Slate has been assisting government agencies to move from the DIACAP to the RMF process, while relieving the stresses that come along with the additional security controls and documentation to achieve their goals."
        }
      ]
    },
    {
      "id": 199,
      "type": "page",
      "title": "Industries",
      "path": "/industries",
      "slug": "industries",
      "parent": 0,
      "date": "July 22, 2018",
      "description": "Industries from Slate Enclave.",
      "hero": "/assets/slateheaderimage.png",
      "images": [],
      "blocks": []
    },
    {
      "id": 197,
      "type": "page",
      "title": "Secure Engineering Integration",
      "path": "/solutions/secure-engineering-integration",
      "slug": "secure-engineering-integration",
      "parent": 10,
      "date": "July 22, 2018",
      "description": "Slate helps design and integrate security solutions for your organization that can withstand modern threats.",
      "hero": "/assets/9-1.png",
      "images": [
        "/assets/9-1.png"
      ],
      "blocks": [
        {
          "type": "paragraph",
          "text": "Slate helps design and integrate security solutions for your organization that can withstand the threats of humans, new technology, and natural disasters. Our team looks at the physical, administrative and technical controls that can help with the engineering aspect of your business model, to ensure the maturity level of your organization is at the highest level possible. We understand that this can be a difficult task to undertake, especially with the boundary of the organization fading away. The internal network is not the only place that needs to be evaluated and protected. Business is conducted both in and out of the corporate office, creating a complex problem that needs to be solved."
        },
        {
          "type": "paragraph",
          "text": "By integrating industry best practices, Slate will address all aspects of your business processes to determine what security controls need to be deployed and how to couple them with the software development life cycle (SDLC). This approach allows security to be integrated into your programs and not forced into the processes after deployment. The result of this approach gives your organization and its information systems a robust security posture, which enables the business to proceed, and will not hinder the process."
        }
      ]
    },
    {
      "id": 196,
      "type": "page",
      "title": "Pentesting",
      "path": "/solutions/pentesting",
      "slug": "pentesting",
      "parent": 10,
      "date": "July 22, 2018",
      "description": "Slate’s team of qualified penetration testers leverage their vast experience with Red Team engagements stemming from the Government, Commercial and Private sectors.",
      "hero": "/assets/10.png",
      "images": [
        "/assets/10.png"
      ],
      "blocks": [
        {
          "type": "paragraph",
          "text": "Pentesting, also known as penetration testing, is a series of security assessments that determine your organization’s vulnerabilities and check on its security posture. In today’s current climate, information data breaches, leaks, insider threats, and espionage are almost inevitable. The entry points to your organization’s security systems have only increased with the use of personal devices and remote employees. Which is why we offer pentesting to reveal and mitigate these risks."
        },
        {
          "type": "paragraph",
          "text": "Slate’s team of qualified penetration testers leverage their vast experience with Red Team engagements to tailor a customized assessment based on your organizational needs. Our experienced team will know if your organization requires a threat and vulnerability assessment, an advanced penetration test, or a combination of the two. These assessments will provide insight to the potential deficiencies and weak points throughout your organization, which can be used as access points for internal and external cyber threats. Based on our findings, we will debrief your staff on the findings and relevant data points so that you can act upon them in a timely manner and mitigate the weaknesses."
        }
      ]
    },
    {
      "id": 195,
      "type": "page",
      "title": "Assessment & Authorization",
      "path": "/solutions/assessment-authorization",
      "slug": "assessment-authorization",
      "parent": 10,
      "date": "July 22, 2018",
      "description": "We will perform an audit and provide a report to senior leadership stating where the deficient security controls are and how to mitigate them.",
      "hero": "/assets/8.png",
      "images": [
        "/assets/8.png"
      ],
      "blocks": [
        {
          "type": "paragraph",
          "text": "Slate’s team is known for our extensive experience performing Assessment & Authorizations (A&A) for federal and government agencies —including U.S. intelligence agencies. We use a systematic approach that incorporates the Risk Management Framework (RMF) to ensure compliance for your organization. Once certified that the program has incorporated the proper level of security controls along with developing the related security documentation to protect their system, an Authorization to Operate (ATO) is granted. This ATO will provide other agencies, along with the owners of the data within the program, the assurance that the program has been secured and is reliable. Once ATO is achieved, federal agencies will be allowed to share data amongst other agencies."
        },
        {
          "type": "paragraph",
          "text": "Slate ensures federal agencies retain ATO and maintain the appropriate security posture through Continuous Monitoring, which promotes a robust patching and evaluation process to validate that the security controls are still working at their highest levels."
        },
        {
          "type": "paragraph",
          "text": "Audits for Non-Federal Organizations"
        },
        {
          "type": "paragraph",
          "text": "For organizations that fall outside of the federal government, Slate offers the same high-level Risk Management Framework (RMF) through our Audit service. Our team performs audits for organizations to determine where their security systems are deficient and how to mitigate these deficiencies."
        }
      ]
    },
    {
      "id": 194,
      "type": "page",
      "title": "CISO as a Service",
      "path": "/solutions/ciso-as-a-service",
      "slug": "ciso-as-a-service",
      "parent": 10,
      "date": "July 22, 2018",
      "description": "Not all organizations can hire a full time CISO to protect their assets from disclosure or ransom even though building a Security Program is an integral part of busi",
      "hero": "/assets/10-1.png",
      "images": [
        "/assets/10-1.png"
      ],
      "blocks": [
        {
          "type": "paragraph",
          "text": "CISO as a Service provides all the benefits of an in-house Chief Information Security Officer (CISO) without the overhead cost. Slate offers CISO as a Service to provide the highest level of integration of your business and security systems. Through CISO as a Service, our team helps align each business unit to maximize their output while securing sensitive and protected data. We assist in evaluating the business processes to properly institute the correct level of security functions—such as deploying policies and procedures which incorporate administrative and technical controls throughout the organization."
        },
        {
          "type": "paragraph",
          "text": "The integration of your business and security systems can only be achieved with the leadership role that a CISO provides. CISO as a Service dives into the culture and information technology of your organization. Our team learns the risk tolerance of your organization and collaborates with your team to incorporate controls that will not hinder their business processes. When this approach is taken, a clear and concise path for creating a security program emerges."
        }
      ]
    },
    {
      "id": 193,
      "type": "page",
      "title": "PHI/PII",
      "path": "/solutions/phi-pii",
      "slug": "phi-pii",
      "parent": 10,
      "date": "July 22, 2018",
      "description": "Slate understands the importance of Personally Identifiable Information (PII) and Protected Health Information (PHI).",
      "hero": "/assets/11.png",
      "images": [
        "/assets/11.png"
      ],
      "blocks": [
        {
          "type": "paragraph",
          "text": "Slate understands the importance of Personally Identifiable Information (PII) and Protected Health Information (PHI). Our team develops custom security systems and programs to protect this private data for your clients, your team, and the reputation of your organization."
        },
        {
          "type": "paragraph",
          "text": "When your organization’s Information System contains data that is considered private, such as Personally Identifiable Information (PII) or Protected Health Information (PHI), you are obligated by specific laws and regulations to protect that information from individuals and entities accessing the data without authorization. This task can be daunting when you must navigate and implement the proper security controls. We can assist your organization with making sure you apply the controls needed along with auditing the controls to validate they are implemented in the appropriate method."
        },
        {
          "type": "paragraph",
          "text": "When you are dealing with PHI, your organization must adhere to the regulations that the Department of Health and Human Services developed, which are known as the Privacy Rule and the Security Rule. The Privacy Rule establishes that organizations must protect all Individually Identifiable Health Information. This data is considered protected health information (PHI). The Security Rule established these rules for electronic PHI."
        },
        {
          "type": "paragraph",
          "text": "Not all organizations deal with healthcare information, but they do contain Personally Identifiable Information (PII). Some entities call this Sensitive Personal Information (SPI), but they are one and the same. This information is considered sensitive since it can identify, contact or locate an individual. There is a large list of information considered to be PII, so it is crucial that your organization understands and protects this data."
        },
        {
          "type": "paragraph",
          "text": "Regardless of the data that your organization contains and utilizes, you must protect it with the appropriate controls which show Due Care. Slate can help develop a strategy to implement these controls and properly evaluate their effectiveness, whether we implement a CISO , Audit or Vulnerability Assessment ."
        }
      ]
    },
    {
      "id": 192,
      "type": "page",
      "title": "Solutions",
      "path": "/solutions-2",
      "slug": "solutions-2",
      "parent": 0,
      "date": "July 22, 2018",
      "description": "Solutions from Slate Enclave.",
      "hero": "/assets/slateheaderimage.png",
      "images": [],
      "blocks": []
    },
    {
      "id": 189,
      "type": "page",
      "title": "About Us",
      "path": "/about-us",
      "slug": "about-us",
      "parent": 0,
      "date": "July 22, 2018",
      "description": "System security and information assurance is the backbone of your organization’s data protection and integrity. Slate enhances your security posture.",
      "hero": "/assets/Untitled-design-7.png",
      "images": [
        "/assets/Untitled-design-7.png",
        "/assets/natalie.png",
        "/assets/DSC_0733-2.jpg",
        "/assets/logo-ITAR.png",
        "/assets/ISC2_logo.png",
        "/assets/images.jpg",
        "/assets/infragard-logo.jpg",
        "/assets/MGMA_State_logo_k.png",
        "/assets/XZyX8mW9_400x400.png"
      ],
      "blocks": [
        {
          "type": "heading",
          "text": "Managing Cyber Risk – Minimizing Exposure"
        },
        {
          "type": "paragraph",
          "text": "At Slate, we know that system security and assurance are the backbones of your organization’s data protection and integrity. Our mission is to offer innovative, mission-critical solutions that provide you and your organization with high levels of confidence, coupled with efficient and scalable systems that meet the specific needs of your business."
        },
        {
          "type": "paragraph",
          "text": "Our team understands that each organization is unique. We deliver custom security solutions tailored to you, your industry, culture, and all of its one-of-a-kind challenges. We provide our clients with security solutions that not only inspire confidence, but accomplish their specific goals and needs."
        },
        {
          "type": "paragraph",
          "text": "Slate is committed to creating and maintaining strong relationships with our clients, built upon a foundation of excellence and trust. Slate’s team is comprised of security experts who maintain standard certifications, DoD 8570 compliance, the appropriate clearances, and continuing education. We take our business and your security very seriously. Our goal with each engagement is to consistently exceed your expectations, while enhancing your security posture."
        },
        {
          "type": "heading",
          "text": "Slate is now an approved Qualified Maryland Cyber Company (QMCC). If you work with us, you may receive tax credits on 50% of our services."
        },
        {
          "type": "heading",
          "text": "Affiliations"
        },
        {
          "type": "heading",
          "text": "Our Team"
        },
        {
          "type": "paragraph",
          "text": "Slate’s team is comprised of highly-skilled, recognized, and respected professionals in the security industry. We maintain standard certifications, DoD 8570 compliance, the appropriate clearances, and continuing education to ensure the highest security of your organization."
        },
        {
          "type": "paragraph",
          "text": "Our team brings over 20 years of experience securing Federal Agencies, Healthcare Firms, Law Firms, and Educational Institutions. We have extensive experience in implementing comprehensive security programs for maximum security organizations and U.S. intelligence agencies."
        },
        {
          "type": "paragraph",
          "text": "Slate’s advisors understand that proper Information Security is more than just a quick solution, which is why we build long-term relationships with our clients. We strive for 100% client satisfaction with each engagement and are committed to exceeding your expectations while enhancing your security posture."
        },
        {
          "type": "heading",
          "text": "“Working with Slate has been a great experience. Their level of service and attention to our business needs brought the appropriate level of security needed to protect our assets. ”"
        },
        {
          "type": "heading",
          "text": "— Gene, Owner of Seidel Subrogation Associates, LLC"
        }
      ]
    },
    {
      "id": 180,
      "type": "page",
      "title": "Privacy Policy",
      "path": "/privacy-policy",
      "slug": "privacy-policy",
      "parent": 0,
      "date": "June 29, 2018",
      "description": "Effective date: October 04, 2018 Slate Encalve, LLC (\"us\", \"we\", or \"our\") operates the https://slateenclave.com/ website (the \"Service\"). This page informs you of o",
      "hero": "/assets/slateheaderimage.png",
      "images": [],
      "blocks": [
        {
          "type": "paragraph",
          "text": "Effective date: October 04, 2018"
        },
        {
          "type": "paragraph",
          "text": "Slate Encalve, LLC (\"us\", \"we\", or \"our\") operates the https://slateenclave.com/ website (the \"Service\")."
        },
        {
          "type": "paragraph",
          "text": "This page informs you of our policies regarding the collection, use, and disclosure of personal data when you use our Service and the choices you have associated with that data. Our Privacy Policy for Slate Encalve, LLC is managed through Free Privacy Policy ."
        },
        {
          "type": "paragraph",
          "text": "We use your data to provide and improve the Service. By using the Service, you agree to the collection and use of information in accordance with this policy. Unless otherwise defined in this Privacy Policy, terms used in this Privacy Policy have the same meanings as in our Terms and Conditions, accessible from https://slateenclave.com/"
        },
        {
          "type": "heading",
          "text": "Information Collection And Use"
        },
        {
          "type": "paragraph",
          "text": "We collect several different types of information for various purposes to provide and improve our Service to you."
        },
        {
          "type": "heading",
          "text": "Types of Data Collected"
        },
        {
          "type": "heading",
          "text": "Personal Data"
        },
        {
          "type": "paragraph",
          "text": "While using our Service, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you (\"Personal Data\"). Personally identifiable information may include, but is not limited to:"
        },
        {
          "type": "list",
          "items": [
            "Email address",
            "First name and last name",
            "Phone number",
            "Address, State, Province, ZIP/Postal code, City",
            "Cookies and Usage Data"
          ]
        },
        {
          "type": "heading",
          "text": "Usage Data"
        },
        {
          "type": "paragraph",
          "text": "We may also collect information how the Service is accessed and used (\"Usage Data\"). This Usage Data may include information such as your computer's Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that you visit, the time and date of your visit, the time spent on those pages, unique device identifiers and other diagnostic data."
        },
        {
          "type": "heading",
          "text": "Tracking & Cookies Data"
        },
        {
          "type": "paragraph",
          "text": "We use cookies and similar tracking technologies to track the activity on our Service and hold certain information."
        },
        {
          "type": "paragraph",
          "text": "Cookies are files with small amount of data which may include an anonymous unique identifier. Cookies are sent to your browser from a website and stored on your device. Tracking technologies also used are beacons, tags, and scripts to collect and track information and to improve and analyze our Service."
        },
        {
          "type": "paragraph",
          "text": "You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our Service."
        },
        {
          "type": "paragraph",
          "text": "Examples of Cookies we use:"
        },
        {
          "type": "list",
          "items": [
            "Session Cookies. We use Session Cookies to operate our Service.",
            "Preference Cookies. We use Preference Cookies to remember your preferences and various settings.",
            "Security Cookies. We use Security Cookies for security purposes."
          ]
        },
        {
          "type": "heading",
          "text": "Use of Data"
        },
        {
          "type": "paragraph",
          "text": "Slate Encalve, LLC uses the collected data for various purposes:"
        },
        {
          "type": "list",
          "items": [
            "To provide and maintain the Service",
            "To notify you about changes to our Service",
            "To allow you to participate in interactive features of our Service when you choose to do so",
            "To provide customer care and support",
            "To provide analysis or valuable information so that we can improve the Service",
            "To monitor the usage of the Service",
            "To detect, prevent and address technical issues"
          ]
        },
        {
          "type": "heading",
          "text": "Transfer Of Data"
        },
        {
          "type": "paragraph",
          "text": "Your information, including Personal Data, may be transferred to ó and maintained on ó computers located outside of your state, province, country or other governmental jurisdiction where the data protection laws may differ than those from your jurisdiction."
        },
        {
          "type": "paragraph",
          "text": "If you are located outside United States and choose to provide information to us, please note that we transfer the data, including Personal Data, to United States and process it there."
        },
        {
          "type": "paragraph",
          "text": "Your consent to this Privacy Policy followed by your submission of such information represents your agreement to that transfer."
        },
        {
          "type": "paragraph",
          "text": "Slate Encalve, LLC will take all steps reasonably necessary to ensure that your data is treated securely and in accordance with this Privacy Policy and no transfer of your Personal Data will take place to an organization or a country unless there are adequate controls in place including the security of your data and other personal information."
        },
        {
          "type": "heading",
          "text": "Disclosure Of Data"
        },
        {
          "type": "heading",
          "text": "Legal Requirements"
        },
        {
          "type": "paragraph",
          "text": "Slate Encalve, LLC may disclose your Personal Data in the good faith belief that such action is necessary to:"
        },
        {
          "type": "list",
          "items": [
            "To comply with a legal obligation",
            "To protect and defend the rights or property of Slate Encalve, LLC",
            "To prevent or investigate possible wrongdoing in connection with the Service",
            "To protect the personal safety of users of the Service or the public",
            "To protect against legal liability"
          ]
        },
        {
          "type": "heading",
          "text": "Security Of Data"
        },
        {
          "type": "paragraph",
          "text": "The security of your data is important to us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While we strive to use commercially acceptable means to protect your Personal Data, we cannot guarantee its absolute security."
        },
        {
          "type": "heading",
          "text": "Service Providers"
        },
        {
          "type": "paragraph",
          "text": "We may employ third party companies and individuals to facilitate our Service (\"Service Providers\"), to provide the Service on our behalf, to perform Service-related services or to assist us in analyzing how our Service is used."
        },
        {
          "type": "paragraph",
          "text": "These third parties have access to your Personal Data only to perform these tasks on our behalf and are obligated not to disclose or use it for any other purpose."
        },
        {
          "type": "heading",
          "text": "Analytics"
        },
        {
          "type": "paragraph",
          "text": "We may use third-party Service Providers to monitor and analyze the use of our Service."
        },
        {
          "type": "list",
          "items": [
            "Google Analytics Google Analytics is a web analytics service offered by Google that tracks and reports website traffic. Google uses the data collected to track and monitor the use of our Service. This data is shared with other Google services. Google may use the collected data to contextualize and personalize the ads of its own advertising network. You can opt-out of having made your activity on the Service available to Google Analytics by installing the Google Analytics opt-out browser add-on. The add-on prevents the Google Analytics JavaScript (ga.js, analytics.js, and dc.js) from sharing information with Google Analytics about visits activity. For more information on the privacy practices of Google, please visit the Google Privacy & Terms web page: https://policies.google.com/privacy?hl=en"
          ]
        },
        {
          "type": "heading",
          "text": "Links To Other Sites"
        },
        {
          "type": "paragraph",
          "text": "Our Service may contain links to other sites that are not operated by us. If you click on a third party link, you will be directed to that third party's site. We strongly advise you to review the Privacy Policy of every site you visit."
        },
        {
          "type": "paragraph",
          "text": "We have no control over and assume no responsibility for the content, privacy policies or practices of any third party sites or services."
        },
        {
          "type": "heading",
          "text": "Children's Privacy"
        },
        {
          "type": "paragraph",
          "text": "Our Service does not address anyone under the age of 18 (\"Children\")."
        },
        {
          "type": "paragraph",
          "text": "We do not knowingly collect personally identifiable information from anyone under the age of 18. If you are a parent or guardian and you are aware that your Children has provided us with Personal Data, please contact us. If we become aware that we have collected Personal Data from children without verification of parental consent, we take steps to remove that information from our servers."
        },
        {
          "type": "heading",
          "text": "Changes To This Privacy Policy"
        },
        {
          "type": "paragraph",
          "text": "We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page."
        },
        {
          "type": "paragraph",
          "text": "We will let you know via email and/or a prominent notice on our Service, prior to the change becoming effective and update the \"effective date\" at the top of this Privacy Policy."
        },
        {
          "type": "paragraph",
          "text": "You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page."
        },
        {
          "type": "heading",
          "text": "Contact Us"
        },
        {
          "type": "paragraph",
          "text": "If you have any questions about this Privacy Policy, please contact us:"
        },
        {
          "type": "list",
          "items": [
            "By email: info@slateenclave.com"
          ]
        }
      ]
    },
    {
      "id": 14,
      "type": "page",
      "title": "Contact",
      "path": "/contact",
      "slug": "contact",
      "parent": 0,
      "date": "March 8, 2017",
      "description": "Contact from Slate Enclave.",
      "hero": "/assets/slateheaderimage.png",
      "images": [],
      "blocks": []
    },
    {
      "id": 12,
      "type": "page",
      "title": "Resources & Industry News",
      "path": "/resources-industry-news",
      "slug": "resources-industry-news",
      "parent": 0,
      "date": "March 8, 2017",
      "description": "Slate understands how challenging it is to keep up with industry news regarding the latest threats, attacks,",
      "hero": "/assets/iStock-816324726-e1536593563643.jpg",
      "images": [
        "/assets/iStock-816324726-e1536593563643.jpg"
      ],
      "blocks": [
        {
          "type": "paragraph",
          "text": "Slate understands how challenging it is to keep up with industry news regarding the latest threats, attacks, emerging and potential threats. The following links are great resources for our staff and customers in helping to understand the current landscape in the Cybersecurity space. Each link has a specialized focus that contains great information. Check back frequently to see additional resources and to keep up with our latest blog posts!"
        }
      ]
    },
    {
      "id": 10,
      "type": "page",
      "title": "Solutions",
      "path": "/solutions",
      "slug": "solutions",
      "parent": 0,
      "date": "March 8, 2017",
      "description": "Solutions from Slate Enclave.",
      "hero": "/assets/slateheaderimage.png",
      "images": [],
      "blocks": []
    },
    {
      "id": 6,
      "type": "page",
      "title": "Home",
      "path": "/",
      "slug": "slate-enclave-the-trusted-partner-for-custom-security-solutions",
      "parent": 0,
      "date": "March 8, 2017",
      "description": "Slate Enclave is the trusted partner for custom security solutions, tailored to your business. Our team knows that system security and information assurance is the b",
      "hero": "/assets/Untitled-design.png",
      "images": [
        "/assets/Untitled-design.png",
        "/assets/reliable.png",
        "/assets/experienced.png",
        "/assets/secure.png"
      ],
      "blocks": [
        {
          "type": "heading",
          "text": "S late is the trusted partner for custom security solutions, tailored to your business."
        },
        {
          "type": "paragraph",
          "text": "Slate is known for our reliability and transparency. Our relationships are built on trust and honest discussions, ensuring our clients understand that we are fully committed to the safety and success of their organization."
        },
        {
          "type": "paragraph",
          "text": "Our team has over 20 years of experience securing Federal, Commercial, and Private organizations, including U.S. intelligence agencies. Our clients know that we have the solutions for all security situations that may arise."
        },
        {
          "type": "paragraph",
          "text": "Slate provides high-quality, thorough security solutions. We approach security from a holistic perspective, starting with your culture and leading into the managerial, technical, and operational aspects of your organization."
        },
        {
          "type": "heading",
          "text": "Case Studies"
        },
        {
          "type": "heading",
          "text": "Healthcare Provider Prepares for Third-Party Audit"
        },
        {
          "type": "paragraph",
          "text": "Healthcare providers need to take special care when it comes to securing their systems and protecting patient privacy. In this case, Slate was engaged by a mid-size healthcare provider to address significant gaps in their security posture that left them vulnerable for an attack. Our team elevated them to a new security posture in preparation for a third-party audit performed by their business partner, that provides medical information to their organization. We performed a critical control assessment to assist them in the process of preparing for the audit."
        },
        {
          "type": "paragraph",
          "text": "Once the assessment was completed, our team provided a scorecard as a starting point to build a program that encompassed the appropriate industry controls to mitigate risks and protect PHI/PII within the organization. As a result, the healthcare provider was able to pass the audit and maintain a high level of security with minimal risk."
        },
        {
          "type": "heading",
          "text": "Law Firm's Approach to Mobile Users & Data Protection"
        },
        {
          "type": "paragraph",
          "text": "Law firms are at significant risk of data breaches that not only jeopardize losing the personal information of clients, but the entire reputation of their firm. In today’s mobile world, law firms are especially vulnerable to significant data breaches because attorneys and administrative staff are working with highly sensitive information and communicating across different technology platforms. In this case, Slate helped a law firm develop a program for the use of personal devices in and out of the office. Our program defined what data is to be stored on different platforms including remote and mobile devices, how it has to be protected, and how long it would be stored, along with other important parameters specific to the firm."
        },
        {
          "type": "paragraph",
          "text": "Slate helps law firms protect their data regardless of whether your employees work in or out-of-office. This case is just one example of a security control our team can assist with during assessments and Security Program implementations."
        },
        {
          "type": "heading",
          "text": "Private School's Need for an Incident Response Plan & Security Program"
        },
        {
          "type": "paragraph",
          "text": "Private schools are common targets for hackers and data breaches because of the need for open communication between teachers and their students through online platforms. In this case, one private school discovered malicious code inside their internal network that provided outside access to adversaries. Without a properly secure network, this school was left vulnerable to a data breach of confidential information."
        },
        {
          "type": "paragraph",
          "text": "After the incident was handled, the private school realized they were not prepared to handle any type of breach, so the team at Slate worked closely with the executive team to develop an Incident Response Plan (IR Plan) that fit the business model of the school. Once the IR Plan was completed and approved, our team then created a comprehensive security plan that the school now uses to mitigate and lower their level of risk. Now the private school is more secure and prepared to handle possible security incidents."
        },
        {
          "type": "heading",
          "text": "By the Numbers"
        },
        {
          "type": "heading",
          "text": "Enhance Your Security Posture Today"
        },
        {
          "type": "heading",
          "text": "“Slate has kept us on our toes from the moment we began working together. We have never felt as secure and as comfortable with the reality of the internet today. I highly recommend Slate to anyone looking for robust data and corporate security solutions.”"
        }
      ]
    }
  ],
  "posts": [
    {
      "id": 1161,
      "type": "post",
      "title": "The Top Metrics to Track in Cybersecurity",
      "path": "/the-top-metrics-to-track-in-cybersecurity",
      "slug": "the-top-metrics-to-track-in-cybersecurity",
      "parent": 0,
      "date": "October 16, 2021",
      "description": "If you are a federal government contractor, you are preparing your organization for the Cybersecurity Maturity Model Certification (CMMC).",
      "hero": "/assets/Untitled-design.jpg",
      "images": [],
      "blocks": [
        {
          "type": "paragraph",
          "text": "Cybersecurity can be daunting, especially if you are unsure which metrics to track. And to be honest, this title is kind of misleading. Metrics, just like cybersecurity, are not one-size-fits-all. The most important metrics that your organization’s security program should track should be driven by what is critical to monitor in your industry and whether you have reporting requirements."
        },
        {
          "type": "paragraph",
          "text": "Before we dive in, we must clarify that first and foremost you need to establish a security program that is customized to your organization and its industry. Once you have this in place, it is time to track metrics to see how well your security system is working and where your organization stands against cyberattacks ."
        },
        {
          "type": "heading",
          "text": "Security Metrics"
        },
        {
          "type": "paragraph",
          "text": "The security metrics your organization should track are dependent on your industry and its reporting requirements."
        },
        {
          "type": "paragraph",
          "text": "For example, private schools are required to comply with the Family Educational Rights and Privacy Act (FERPA) . After an initial impact assessment, the private school may determine that data tagging student records and tracking the movements via logging is vital to their security program. They may also want to track data breach attempts based on specific thresholds to see where hackers are most interested."
        },
        {
          "type": "paragraph",
          "text": "In another example, a manufacturing plant that handles legacy equipment is only profitable and secure if it maintains a certain interval speed. If the manufacturing is stopped for any reason, it could result in large-scale losses each hour. The executive team may want to track the recovery time and pinpoint weak areas in the production line that may need to be corrected."
        },
        {
          "type": "heading",
          "text": "How to Determine Your Security Metrics"
        },
        {
          "type": "paragraph",
          "text": "As is evident from these two scenarios, each organization needs to determine what metrics are important to track based on their specific needs. Each metric is equally important to the other. However, the process of determining what metrics are important to the organization should be the same regardless of the business model."
        },
        {
          "type": "paragraph",
          "text": "The first step is to understand the core business functions and values of your organization. This will help drive the security metrics and outcomes. We encourage you to speak with each business unit to understand their operations and identify which data elements are most important to them. Then, you can begin to develop the bigger picture for your security system."
        },
        {
          "type": "paragraph",
          "text": "As your security program matures, you may find that the metrics will change in tandem. The point of this exercise is to fully understand what is important to the organization so the metrics presented to the executive team have value."
        },
        {
          "type": "paragraph",
          "text": "If you have questions about cybersecurity and which metrics to track, contact us . Slate Enclave is the trusted partner for custom security solutions, tailored to your business."
        },
        {
          "type": "heading",
          "text": "About Slate"
        },
        {
          "type": "paragraph",
          "text": "Slate is known for providing security solutions for Federal Agencies—including implementing comprehensive security programs for maximum security organizations and U.S. intelligence agencies. Our team works closely with federal government contractors to help them prepare for the upcoming Cybersecurity Maturity Model Certification (CMMC) standards."
        },
        {
          "type": "paragraph",
          "text": "Slate is an approved Registered Provider Organization (RPO) within the CMMC Marketplace. This means we completed all the requirements set by the CMMC-AB Code of Professional Conduct and have been vetted to help organizations prepare for the CMMC. We are also in the process of becoming a certified CMMC Third-Party Assessor Organization (C3PAO). Our team is comprised of highly skilled, recognized, and respected professionals in the security industry. We maintain standard certifications, DoD 8570 compliance, the appropriate clearances, and continuing education to ensure the highest security of your organization."
        },
        {
          "type": "paragraph",
          "text": "Related content:"
        },
        {
          "type": "paragraph",
          "text": "Our CMMC/DFARS Solutions The First Steps Towards CMMC Compliance The Role of Cyber Awareness in the Workplace Starting A Cyber Awareness Program…"
        }
      ]
    },
    {
      "id": 1135,
      "type": "post",
      "title": "The New CMMC Controls for Security Awareness and Training",
      "path": "/the-new-cmmc-controls-for-security-awareness-and-training",
      "slug": "the-new-cmmc-controls-for-security-awareness-and-training",
      "parent": 0,
      "date": "July 27, 2021",
      "description": "If you are a federal government contractor, you are preparing your organization for the Cybersecurity Maturity Model Certification (CMMC).",
      "hero": "/assets/Untitled-design-14.png",
      "images": [],
      "blocks": [
        {
          "type": "paragraph",
          "text": "If you are a federal government contractor, you are preparing your organization for the Cybersecurity Maturity Model Certification (CMMC). The United States Department of Defense is moving towards the CMMC to standardize the cybersecurity requirements across the Defense Industrial Base (DIB). The goal is to ensure the federal government’s controlled unclassified information (CUI) is not at risk."
        },
        {
          "type": "heading",
          "text": "Security Awareness and Training Controls"
        },
        {
          "type": "paragraph",
          "text": "Over the last few months, the CMMC framework has added additional controls to the base of NIST 800-171. One set of controls that this occurred within, is Security Awareness and Training."
        },
        {
          "type": "paragraph",
          "text": "Before, as organizations were evaluating their compliance with NIST 800-171, they had to confirm that they were in compliance with three areas within Security Awareness and Training:"
        },
        {
          "type": "list",
          "items": [
            "General – This control validates that the appropriate personnel are aware of the risks associated with their tasks, along with the administrative controls to protect them.",
            "Duty Specific – This control verifies that the personnel are trained appropriately for their tasks and the possible security risks.",
            "Insider Threat Awareness – This control ensures Security Awareness Training, including Insider Threats, is provided to everyone in the organization."
          ]
        },
        {
          "type": "heading",
          "text": "The New CMMC Controls"
        },
        {
          "type": "paragraph",
          "text": "As the CMMC is starting to take over as the framework of choice for the Defense Industrial Base, three additional controls were added to the previous set:"
        },
        {
          "type": "list",
          "items": [
            "Establish Policy – This new control requires organizations to implement a policy that includes Security Awareness and Training.",
            "Document Practices – This new control requires organizations to document the process of implementing the training.",
            "Manage – This new control requires organizations to maintain a resource plan and historical report of training being performed."
          ]
        },
        {
          "type": "heading",
          "text": "What the New Controls Mean"
        },
        {
          "type": "paragraph",
          "text": "The addition of the three controls for the Security Awareness and Training family verifies that the organization has implemented a formal training program, moving from the ad-hoc approach that NIST 800-171 verified. In the past, it was fine for your organization to just have a training program. Under the CMMC, your training program needs to be formalized with executive approval and historical data showing that it was implemented and used."
        },
        {
          "type": "paragraph",
          "text": "Formalizing the program ensures that the organization does not miss training requirements and verifies that the program stays current. With CMMC level 3 requirements, just having a defined training program, whether internal or externally managed, is sufficient to pass the audit. As organizations start to look at Levels 4 and 5, the controls change, requiring the end-users to have interactive training modules along with tests, which verify the users understand the content."
        },
        {
          "type": "paragraph",
          "text": "With a robust security awareness program, organizations can review the data from the training to determine what weak points exist within the organization, allowing for course-correcting within the training modules."
        },
        {
          "type": "heading",
          "text": "How Slate Can Help"
        },
        {
          "type": "paragraph",
          "text": "Our team works closely with federal government contractors to prepare them for the upcoming Cybersecurity Maturity Model Certification (CMMC). We ensure federal government contractors meet or exceed all the CMMC controls, including the requirements for Security Awareness and Training."
        },
        {
          "type": "paragraph",
          "text": "If you have questions about preparing for the CMMC, contact us . Slate Enclave is the trusted partner for custom security solutions, tailored to your business."
        },
        {
          "type": "heading",
          "text": "About Slate"
        },
        {
          "type": "paragraph",
          "text": "Slate is known for providing security solutions for Federal Agencies—including implementing comprehensive security programs for maximum security organizations and U.S. intelligence agencies. Our team works closely with federal government contractors to help them prepare for the upcoming Cybersecurity Maturity Model Certification (CMMC) standards."
        },
        {
          "type": "paragraph",
          "text": "Slate is an approved Registered Provider Organization (RPO) within the CMMC Marketplace. This means we completed all the requirements set by the CMMC-AB Code of Professional Conduct and have been vetted to help organizations prepare for the CMMC. We are also in the process of becoming a certified CMMC Third-Party Assessor Organization (C3PAO). Our team is comprised of highly skilled, recognized, and respected professionals in the security industry. We maintain standard certifications, DoD 8570 compliance, the appropriate clearances, and continuing education to ensure the highest security of your organization."
        },
        {
          "type": "paragraph",
          "text": "Related content:"
        },
        {
          "type": "paragraph",
          "text": "Our CMMC/DFARS Solutions The First Steps Towards CMMC Compliance The Role of Cyber Awareness in the Workplace Starting A Cyber Awareness Program…"
        }
      ]
    },
    {
      "id": 1118,
      "type": "post",
      "title": "The Benefits of Hiring a Virtual CISO",
      "path": "/the-benefits-of-hiring-a-virtual-ciso",
      "slug": "the-benefits-of-hiring-a-virtual-ciso",
      "parent": 0,
      "date": "June 16, 2021",
      "description": "Our day-to-day lives have become so busy, that we often forget to maintain and update passwords unless it is forced upon us by third-party applications or corporate requirements.",
      "hero": "/assets/Untitled-design-2-1.png",
      "images": [],
      "blocks": [
        {
          "type": "heading",
          "text": "What is a vCISO?"
        },
        {
          "type": "paragraph",
          "text": "Virtual CISO, vCISO, Outsourced CISO, CISO as a Service … these are all names that mean the same thing—hiring an outside expert to be your Chief Information Security Officer (CISO)."
        },
        {
          "type": "heading",
          "text": "What are the benefits of hiring a vCISO?"
        },
        {
          "type": "list",
          "items": [
            "Save Time, Money & Energy. Rather than putting yourself through a hiring process only to pay an in-house Chief Information Security Officer (CISO) an average total compensation of $291,063, save 40-50% by outsourcing this role to the experts at Slate Enclave.",
            "Certification, Qualification, Expertise. Specialists are trained for a reason—not all cybersecurity problems are the same. By outsourcing your cyber needs to a vCISO, all your issues receive impeccable insight, overview, and attention to detail.",
            "Rapid, New Technology Implementation. Slate Enclave has its sights set on emerging cyber risks along with relevant technologies and trends. Slate understands how to properly and perpetually improve your security posture.",
            "Cyber Security Plan Frees You to Focus on Core Business. At Slate, we know that system security and information assurance is the backbone of your organization's data protection and integrity. A vCISO allow you to focus on the work you love to do, with the security of your company and customers safe in hand.",
            "Risk Reduction, Compliance, and Security. We strive to offer innovative, mission-critical solutions that provide you and your organization with high levels of confidence, coupled with efficient and scalable systems that meet the specific needs of your business."
          ]
        },
        {
          "type": "heading",
          "text": "Partner with Slate"
        },
        {
          "type": "paragraph",
          "text": "CISO as a Service provides all the benefits of an in-house Chief Information Security Officer (CISO) without the overhead cost. Slate offers CISO as a Service to provide the highest level of integration of your business and security systems. Through CISO as a Service, our team helps align each business unit to maximize their output while securing sensitive and protected data. We assist in evaluating the business processes to properly institute the correct level of security functions—such as deploying policies and procedures which incorporate administrative and technical controls throughout the organization."
        },
        {
          "type": "paragraph",
          "text": "The integration of your business and security systems can only be achieved with the leadership role that a CISO provides. CISO as a Service dives into the culture and information technology of your organization. Our team learns the risk tolerance of your organization and collaborates with your team to incorporate controls that will not hinder their business processes. When this approach is taken, a clear and concise path for creating a security program emerges."
        },
        {
          "type": "paragraph",
          "text": "If you have questions about hiring a vCISO, contact us . Slate Enclave is the trusted partner for custom security solutions, tailored to your business. We provide CISO as a Service to organizations in need of a security expert to guide their team."
        }
      ]
    },
    {
      "id": 1099,
      "type": "post",
      "title": "How Password Managers Help Secure Your Information Online",
      "path": "/how-password-managers-help-secure-your-information-online",
      "slug": "how-password-managers-help-secure-your-information-online",
      "parent": 0,
      "date": "May 12, 2021",
      "description": "Our day-to-day lives have become so busy, that we often forget to maintain and update passwords unless it is forced upon us by third-party applications or corporate requirements.",
      "hero": "/assets/Untitled-design-12.png",
      "images": [],
      "blocks": [
        {
          "type": "paragraph",
          "text": "Our day-to-day lives have become so busy, that we often forget to maintain and update passwords unless it is forced upon us by third-party applications or corporate requirements. As our lives move into a more remote lifestyle, a lot of our work has moved into cloud-based services. Securing your online accounts with strong passwords and trying to memorize lots of passwords has been a challenge. Taking this one step further, people tend to re-use the same password for multiple log-ins, which further weakens your security footprint."
        },
        {
          "type": "paragraph",
          "text": "The reality is, however, that passwords need to be changed regularly to secure your private information. At Slate, we encourage you to consider using a password manager to help make this process easier and more streamlined."
        },
        {
          "type": "heading",
          "text": "Password Managers"
        },
        {
          "type": "paragraph",
          "text": "One solution is to use a password manager, which, essentially is an encrypted vault that stores login information. Password managers store your login information for all the websites you use and help you log into them automatically. They encrypt your password database with a master password. The master password is the only one that will need to be remembered. Password managers help with overseeing your passwords by auto-filling forms during the login process. Additionally, password managers help with auto-filling the other fields of information on these sites—such as credit card information, addresses, and biometric data."
        },
        {
          "type": "paragraph",
          "text": "When choosing a password manager, you will find that there are multiple options to compare, which can seem overwhelming. There are some things to keep in mind when choosing a password manager, keeping in mind that with so many features, some features can appeal to one person while those features may not be important to another. Each should provide a free option to start you on the journey to evaluate how well, or not well, they integrate within your daily routine."
        },
        {
          "type": "paragraph",
          "text": "Once you do decide, the first step is to choose a secure password, or passphrase, that will be used as the master password. This master password will be used to unlock the local password manager. When creating passwords for your sites and applications, the password manager should provide the ability to generate a strong password, which prevents you from using the same password across multiple sites. The password manager can be used across multiple devices if you have the application or browser extension installed."
        },
        {
          "type": "paragraph",
          "text": "A few Password Managers that Slate has implemented and recommended in the past are listed here:"
        },
        {
          "type": "list",
          "items": [
            "1Password - https://1password.com/",
            "Bitwarden - https://bitwarden.com/",
            "LastPass - https://www.lastpass.com/"
          ]
        },
        {
          "type": "heading",
          "text": "Multi-Factor Authentication Codes"
        },
        {
          "type": "paragraph",
          "text": "In addition to using a password manager, we encourage you to use multi-factor authentication codes wherever possible. Multi-factor authentication codes are when a website or platform asks you to send a code, typically to your phone, to verify it is you and not a hacker trying to access your account. Nowadays, most websites, especially those that handle sensitive information, enable you to use at least two-factor authentication codes."
        },
        {
          "type": "paragraph",
          "text": "If you have questions about cybersecurity and how to safeguard your organization, contact us . Slate Enclave is the trusted partner for custom security solutions, tailored to your business. Our team performs audits for organizations to determine where their security systems are deficient and how to mitigate these deficiencies."
        }
      ]
    },
    {
      "id": 1057,
      "type": "post",
      "title": "10 Ways to Secure Your Remote Workforce",
      "path": "/10-ways-to-secure-your-remote-workforce",
      "slug": "10-ways-to-secure-your-remote-workforce",
      "parent": 0,
      "date": "March 4, 2021",
      "description": "Almost one year has passed since COVID-19 changed our daily lives, from how we interact with friends and family to how we conduct our daily work efforts.",
      "hero": "/assets/Copy-of-Untitled.png",
      "images": [],
      "blocks": [
        {
          "type": "paragraph",
          "text": "Almost one year has passed since COVID-19 changed our daily lives, from how we interact with friends and family to how we conduct our daily work efforts. Over this time, we have found that the move to a more remote workforce has also brought some undesired security consequences. Most organizations were forced to rapidly transition to a remote business model that they may not have been prepared to move into. Information Technology (IT) Departments deployed remote capabilities so their workforce could continue to operate, all while dismissing security controls that they would otherwise be sensitive to applying before these capabilities were deployed."
        },
        {
          "type": "paragraph",
          "text": "Now we find ourselves trying to close the gaps that were ignored during deployment. And some organizations are finding it difficult to bake security into a remote workforce process that has been established for months now."
        },
        {
          "type": "paragraph",
          "text": "As a result, organizations are finding that they will need to roll back certain deployments and redeploy with the appropriate security controls or deploy a new solution and process. Either way, it is a necessary process since security incidents are on the rise with a larger portion of the workforce working remotely."
        },
        {
          "type": "paragraph",
          "text": "Approximately, 42% of the workforce is working remotely . With this increase of remote employees, cybersecurity threats and scams are on the rise. Organizations must change their approach to how they protect their infrastructure and their workforce. As the Washington Post reported, global losses have already reached almost $1 trillion . Not only this but as of February 2021, the Department of Homeland Security reported about 80,000 website domains used to falsely sell COVID-19 vaccines . These websites were found to collect sensitive information from individuals, from Personal Information to Credit Card Numbers."
        },
        {
          "type": "paragraph",
          "text": "Organizations must keep moving forward with developing a proper security program to counter these threats."
        },
        {
          "type": "heading",
          "text": "Here are 10 ways to protect your organization and its employees:"
        },
        {
          "type": "paragraph",
          "text": "1. Security Policies . Update your security policies so they are current and relevant to the new, remote landscape."
        },
        {
          "type": "paragraph",
          "text": "2. Incident Response Plans . Ensure your Incident Response plans are developed properly, tested, and ready to execute."
        },
        {
          "type": "paragraph",
          "text": "3. Cyber Awareness Training . Make sure to properly educate your employees on the common ways threats can attempt to gain access to their system and teach them ways to mitigate these threats. We recommend providing a regular security quiz with your entire workforce."
        },
        {
          "type": "paragraph",
          "text": "4. Send Security Alerts . Have your team monitor the latest security news and update your employees on new threats. For example, your employees should be aware of the COVID-19 vaccine website scams."
        },
        {
          "type": "paragraph",
          "text": "5. Properly Segment Networks . As more employees are remote, make sure they cannot access sensitive areas of the network while connected is crucial. This can help isolate and contain infections if one does occur."
        },
        {
          "type": "paragraph",
          "text": "6. Data Loss Protection (DLP) . Understanding the traffic and data flow of your environment is crucial. Once you do, you can control data flow and protect from potential loss before the data leaves."
        },
        {
          "type": "paragraph",
          "text": "7. Intrusion Detection & Protection . If you understand your nodes and data flow, you will now be able to alert and potentially block malicious access."
        },
        {
          "type": "paragraph",
          "text": "8. Logging & Alerting . Having the ability to properly log incidents and alert on them is critical in preventing a potentially disastrous situation from getting worse. If you are not aware that an incident has occurred, how can you react to it?"
        },
        {
          "type": "paragraph",
          "text": "9. Multifactor Authentication . This adds an additional step to the authentication process of accessing your infrastructure. It is typically a username and password with the second step of using a pin."
        },
        {
          "type": "paragraph",
          "text": "10. Patching . One of the most underrated tasks of organizations. This is by far the one thing that could prevent a breach or back door from occurring since most attackers look for flaws in code to take advantage of. Having a proper patch management program in place is critical."
        },
        {
          "type": "paragraph",
          "text": "As the threat of attacks increase, everyone must be vigilant in protecting their organization and their assets. Implementing these steps at the enterprise and the endpoints should help with addressing the most common security risks facing our workforce. Keep in mind—nothing here is static. Security is a fluid process and these processes should be tested for their effectiveness."
        },
        {
          "type": "paragraph",
          "text": "If you have questions about cybersecurity and how to safeguard your organization, contact us . Slate Enclave is the trusted partner for custom security solutions, tailored to your business. Our team performs audits for organizations to determine where their security systems are deficient and how to mitigate these deficiencies."
        }
      ]
    },
    {
      "id": 1036,
      "type": "post",
      "title": "FAQ — What is the Family Educational Rights and Privacy Act (FERPA)?",
      "path": "/what-is-the-family-educational-rights-and-privacy-act",
      "slug": "what-is-the-family-educational-rights-and-privacy-act",
      "parent": 0,
      "date": "February 15, 2021",
      "description": "At Slate Enclave, our private school clients have a lot of questions when it comes to FERPA and how they can protect student education records.",
      "hero": "/assets/Untitled-design-11.png",
      "images": [],
      "blocks": [
        {
          "type": "paragraph",
          "text": "At Slate Enclave , our private school clients have a lot of questions when it comes to FERPA and how they can protect student education records. The Family Educational Rights and Privacy Act (FERPA) is a federal law that protects students’ private information in schools that receive funds from the U.S. Department of Education ."
        },
        {
          "type": "paragraph",
          "text": "When it comes to data breaches, we usually hear news stories about hackers exposing Protected Health Information (PHI) records from healthcare organizations or stealing Personally Identifiable Information (PII) stolen from large organizations like Target or Equifax ."
        },
        {
          "type": "paragraph",
          "text": "However, in the education sector, we are noticing an uptick in data breaches leaking student education records. Just this November 2020, the Baltimore County Public Schools system shut down for several days after a ransomware attack. Comparitech notes that since 2005, more than 24.5 million records have been leaked from U.S. schools alone. FERPA is designed to protect students’ private information and hold schools accountable for these data breaches when they occur."
        },
        {
          "type": "heading",
          "text": "Student Education Records"
        },
        {
          "type": "paragraph",
          "text": "Student education records include a multitude of Personally Identifiable Information (PII) and Protected Health Information (PHI) . People with access to student education records can find out the student’s name, parents’ names, address, contact information, grades, test results, class schedules, previous schools attended, disciplinary actions received, any health information provided to the school, as well as special education records and more."
        },
        {
          "type": "paragraph",
          "text": "The depth of information included in student education records is enough for hackers to open credit or steal identities. Since most children and young adults are not tracking their personal credit, student education records are very appealing to malicious hackers."
        },
        {
          "type": "paragraph",
          "text": "With an understanding of what needs to be protected, the U.S. Department of Education has provided guidelines that can assist in protecting this data ."
        },
        {
          "type": "heading",
          "text": "Family Educational Rights and Privacy Act (FERPA)"
        },
        {
          "type": "paragraph",
          "text": "In today’s digital world, most industries have regulations and frameworks to protect the privacy of individuals, and students are no different. FERPA protects the privacy of parents and children under the age of 18 by providing the following rights:"
        },
        {
          "type": "list",
          "items": [
            "Giving parents and eligible students access to their child’s educational records.",
            "The ability for parents and eligible students to obtain records and amend them when necessary.",
            "Require schools to receive written permission from a parent or the eligible student to release any student education record.",
            "Allow schools to disclose student education records to specific parties under specific conditions, like the state and local authorities."
          ]
        },
        {
          "type": "paragraph",
          "text": "Under FERPA, schools are also allowed to release student directories, as long as the parents and eligible students are informed and have enough time to request not to be included in the directory."
        },
        {
          "type": "heading",
          "text": "FERPA Security Solutions"
        },
        {
          "type": "paragraph",
          "text": "With the rise in data breaches, educational institutions must take necessary precautions to prevent cyberattacks and have a plan in place if an attack occurs. If a school falls victim to a data breach, FERPA requires the school to inform the parents and eligible students and holds them liable for a fine of, on average, $250 per record."
        },
        {
          "type": "paragraph",
          "text": "Schools can protect student education records by implementing similar frameworks and security solutions used to protect PHI. At Slate Enclave , we help our clients implement a comprehensive plan, such as the Cybersecurity Framework, and apply the appropriate family of controls to protect the student data. We ensure our security solutions involve all stakeholders, and have the appropriate buy-in and support from all business units. We also take into account that most school information systems are very complex and require the integration of legacy systems with new systems."
        },
        {
          "type": "paragraph",
          "text": "Once the proper framework is in place, it is imperative that best practices are followed and the controls are monitored to ensure the continued protection of student education records. And should a data breach occur, we help our clients take the right steps to mitigate the situation, prevent data loss, and recover stolen records promptly. As always, our goal is to prevent data breaches from happening in the first place."
        },
        {
          "type": "paragraph",
          "text": "If you have questions about cybersecurity and how to safeguard your private school, contact us . Slate Enclave is the trusted partner for custom security solutions, tailored to your organization. Our team performs audits for organizations to determine where their security systems are deficient and how to mitigate these deficiencies."
        }
      ]
    },
    {
      "id": 1025,
      "type": "post",
      "title": "The Troubling Cybersecurity Trend in Healthcare",
      "path": "/the-troubling-cybersecurity-trend-in-healthcare-2",
      "slug": "the-troubling-cybersecurity-trend-in-healthcare-2",
      "parent": 0,
      "date": "January 14, 2021",
      "description": "HIPAA Journal published their list of the largest Healthcare Data Breaches for 2020 and it shows a troubling trend over the past 10 years.",
      "hero": "/assets/Untitled-design-10.png",
      "images": [],
      "blocks": [
        {
          "type": "paragraph",
          "text": "HIPAA Journal published their list of the largest Healthcare Data Breaches for 2020 and it shows a troubling trend over the past 10 years. In 2010, there were 199 reported breaches. That number increased to 616 reported healthcare breaches in 2020. These numbers are on the conservative side because they only include breaches of more than 500 records. Healthcare organizations are only legally required to announce a data breach at this amount."
        },
        {
          "type": "heading",
          "text": "We can only imagine, how many breaches occurred with healthcare organizations that were under 500 records?"
        },
        {
          "type": "paragraph",
          "text": "A number of the listed healthcare organizations were affected by a data breach at their software service provider, Blackbaud. The ransomware attack affected approximately 8 million records. This type of risk shows how critical it is to verify all appropriate security protections are in place before engaging with a provider of services. Blackbaud’s ransomware attack affected more than the healthcare industry, they also provided services to educational institutions that fell victim to data loss. To put this into perspective, Blackbaud had to navigate the Health Insurance Portability and Accountability Act (HIPAA) and Family Educational Rights and Privacy Act (FERPA) requirements—both of which have strong policies to protect Personally Identifiable Information (PII) and Protected Health Information (PHI)."
        },
        {
          "type": "heading",
          "text": "The Takeaway"
        },
        {
          "type": "paragraph",
          "text": "In today’s digital age, we must recognize how quickly technology is being integrated into healthcare organizations. As in most industries, healthcare organizations are deciding to offload managed services to better serve their patients."
        },
        {
          "type": "paragraph",
          "text": "Unfortunately, proper due diligence is not considered when deciding what service provider will be used. The cost typically becomes the biggest factor when deciding on the preferred provider, whereas it should be a combination of risk posture and tolerance in addition to the cost."
        },
        {
          "type": "paragraph",
          "text": "Additionally, when negotiating with service providers, healthcare organizations need to ensure that an initial security impact analysis will be performed and assessed periodically. This will make sure that the organization is properly maintaining all security-related controls and that new risks have not been introduced since the prior assessment."
        },
        {
          "type": "paragraph",
          "text": "If you have questions about cybersecurity and how to safeguard your organization, contact us . Slate Enclave is the trusted partner for custom security solutions, tailored to your business. Our team performs audits for organizations to determine where their security systems are deficient and how to mitigate these deficiencies."
        }
      ]
    },
    {
      "id": 1005,
      "type": "post",
      "title": "Cyberattacks & Your Organization’s Reputation",
      "path": "/cyberattacks-and-your-organizations-reputation",
      "slug": "cyberattacks-and-your-organizations-reputation",
      "parent": 0,
      "date": "December 9, 2020",
      "description": "Cyberattacks have a tremendous impact on an organization’s reputation. According to Varonis, 80% of consumers will not use a business that was a victim to a breach. ",
      "hero": "/assets/Untitled-design-5-1.png",
      "images": [],
      "blocks": [
        {
          "type": "paragraph",
          "text": "In the last week alone, there are have been two major ransomware attacks in the state of Maryland. The first ransomware attack shut down Baltimore County Public Schools for three days. The second, unrelated attack prevented medical professionals at the Greater Baltimore Medical Center (GBMC) from accessing patients’ medical portals . Now, these organizations are left attempting to salvage both their cybersecurity systems and their reputations. Email notices have gone out to their respective students and medical clientele, notifying them of any possible data leaks and how they are managing the situation."
        },
        {
          "type": "heading",
          "text": "Cyberattacks Impact on Reputation"
        },
        {
          "type": "paragraph",
          "text": "Cyberattacks have a tremendous impact on an organization’s reputation. According to Varonis, 80% of consumers will not use a business that was a victim to a breach . Additionally, 85% will tell others of the incident , showing that even if a person is not a victim of the breach, they will still be aware of the organization's breach and potentially not use them."
        },
        {
          "type": "heading",
          "text": "Measuring the Damage To Reputation"
        },
        {
          "type": "paragraph",
          "text": "One of the most difficult measurements in cybersecurity is the damage to your organization’s reputation. Afterall, reputation can be equated to a number of different factors within an organization. However, we can most easily see the damage to reputation by looking at publicly traded companies and their stock prices. For example, in 2014, Target’s stock fell 11% after the retailer announced that it was a victim of a data breach. Over 70 million people and 40 million accounts were exposed, which resulted in $61 million in related costs and a public relations nightmare."
        },
        {
          "type": "paragraph",
          "text": "Small businesses were the most targeted group for data breaches in 2019. If you are the owner of private organization, you are probably left wondering what to do in the event of a cyberattack and how to measure the damage to your reputation. Of course, there are tangible items that can be measured—legal liabilities, customer relations, regulatory compliance costs, technical recovery costs, etc.—but your organization’s overall reputation can take months, if not years to recover."
        },
        {
          "type": "heading",
          "text": "Managing Reputation After An Attack"
        },
        {
          "type": "paragraph",
          "text": "The steps your organization takes after a cyberattack can make or break its reputation. The following weeks and months are crucial to gain back the trust of your clients. There will be a large increase of calls and messages from your customers and partners to determine how their Personally Identifiable Information (PII) will be protected in the future. If these are not properly thought out and clearly defined, it could push your customers and partners further away. When dealing with damage control, it is imperative to be clear and open regarding the corrective action plans; this shows everyone that the organization is not hiding additional issues and is being as honest as possible."
        },
        {
          "type": "heading",
          "text": "Preventing Cyberattacks"
        },
        {
          "type": "paragraph",
          "text": "The best path for each organization is to prepare for the likely outcome of a breach by developing a comprehensive Incident Response Plan while running through tabletop exercises to test it. Each tabletop exercise should test different business components and identify gaps in the plan so they can be mitigated. This helps test the organizations readiness along with the supporting components of the IR Plan, such as recovery sites and vendor responsiveness."
        },
        {
          "type": "paragraph",
          "text": "If you have questions about cybersecurity and how to safeguard your reputation, contact us . Slate Enclave is the trusted partner for custom security solutions, tailored to your business. Our team performs audits for organizations to determine where their security systems are deficient and how to mitigate these deficiencies."
        }
      ]
    },
    {
      "id": 985,
      "type": "post",
      "title": "The First Steps Towards CMMC Compliance",
      "path": "/the-first-steps-towards-cmmc-compliance",
      "slug": "the-first-steps-towards-cmmc-compliance",
      "parent": 0,
      "date": "November 21, 2020",
      "description": "If you are a Government Contractor with a DFARS 252.204-7012 clause in your contract, the U.S. Department of Defense has announced a new interim rule, which goes into effect on November 30, 2020.",
      "hero": "/assets/Untitled-design-9.png",
      "images": [],
      "blocks": [
        {
          "type": "paragraph",
          "text": "If you are a Government Contractor with a DFARS 252.204-7012 clause in your contract, the U.S. Department of Defense has announced a new interim rule, which goes into effect on November 30, 2020."
        },
        {
          "type": "paragraph",
          "text": "The Cybersecurity Maturity Model Certification (CMMC) Interim Rule was issued on September 29, 2020, to accelerate government contractors’ preparation for when the CMMC goes into effect. Despite the fact that CMMC is projected to go into effect in 2025, the CMMC Interim Rule has renewed its sense of importance. Additionally, the tight deadline has created a sense of panic that could result in an inefficient and costly path towards certification. We encourage all government contractors to take a step back and recognize the importance of properly planning and projecting the path to CMMC compliance."
        },
        {
          "type": "heading",
          "text": "What are the first steps to CMMC compliance?"
        },
        {
          "type": "paragraph",
          "text": "The first step towards CMMC compliance is to complete either a self-assessment or a third-party assessment to get a baseline and see how close—or how far away—your organization is from meeting the minimum requirements. The third-party assessment will discover inadequate system setups and processes that may not meet all the required controls. The first step to ensuring your organization’s compliance is to take a closer look at its networks and procedures."
        },
        {
          "type": "paragraph",
          "text": "Once you have the third-party assessment’s baseline, you will need to implement a gap analysis to have a better understanding of your organization’s security posture and what areas need to be attended to. Without a proper gap analysis, it is impossible to know what changes your organization needs to make before it meets the required CMMC Level."
        },
        {
          "type": "paragraph",
          "text": "The gap analysis will also assist with developing a remediation plan based on the Plan of Action and Milestones (POAM). A remediation plan may involve small corrective actions to a network and/or its processes. In addition, it may involve more extensive changes, including developing compliant networks and policies or processes."
        },
        {
          "type": "paragraph",
          "text": "Once the remediation plan is complete and your organization’s systems and procedures are compliant with the appropriate CMMC Level, your organization will have the tools and processes in place to monitor, detect, and report on cybersecurity incidents within the infrastructure."
        },
        {
          "type": "heading",
          "text": "What does the CMMC mean for the future of government contracting?"
        },
        {
          "type": "paragraph",
          "text": "As of today, the CMMC Level III Certification seems to be the standard that will be required for contract awards. Therefore, it is extremely important that government contractors are prepared to pass the CMMC audit as soon as possible. If you are not prepared to pass your desired CMMC Level, your organization will run the risk of being unable to offer products and services to the DoD for an extended period, or have your contract revoked altogether."
        },
        {
          "type": "paragraph",
          "text": "If you are unsure about your CMMC compliance and completing the self-assessment, contact us as soon as possible to schedule your free consultation. Slate Enclave can help you complete your CMMC self-assessment in a timely manner."
        }
      ]
    },
    {
      "id": 764,
      "type": "post",
      "title": "The Aftermath Of An Assessment",
      "path": "/the-aftermath-of-an-assessment",
      "slug": "the-aftermath-of-an-assessment",
      "parent": 0,
      "date": "June 18, 2020",
      "description": "You just had your Security Assessment completed and received the debrief, which is a report detailing each potential security vulnerability that was identified.",
      "hero": "/assets/slateheaderimage.png",
      "images": [],
      "blocks": [
        {
          "type": "paragraph",
          "text": "You just had your Security Assessment completed and received the debrief, which is a report detailing each potential security vulnerability that was identified. As many organizations have done in the past, you review the report and wonder where to begin. These reports could be lengthy if the assessment identified a large amount of potential vulnerabilities. Most organizations read the executive summary and realize that they do not have the experience or background to mitigate the potential vulnerabilities that were identified so they toss the report to the bottom of their to-do list and hope for the best."
        },
        {
          "type": "paragraph",
          "text": "As some security firms fail to properly educate their client on what the report will contain along with not properly guiding the client into their next phase, top tier security firms are left picking up the pieces as we need to assess what the previous firm completed and where they left off. All security firms should explain their findings and provide a high-level approach on ways to mitigate the potential vulnerabilities that were found. Additionally, most organizations assume that security programs can be embedded into other “technical” business units whose primary focus is not securing the enterprise. This causes multiple stumbling blocks when the mitigation steps are being implemented."
        },
        {
          "type": "paragraph",
          "text": "This is where Slate takes a different approach when we perform our assessments. We look at our clients as a Partner, educating them on why failures occur with specific security controls. If they do not understand the Control that failed and why, they are doomed to never correct it. This may take more time during the assessment, but this exchange of information creates a level of trust and understanding to show that we are really there to assist them and not tear down their infrastructure."
        },
        {
          "type": "paragraph",
          "text": "When we review the debrief with our partners, we suggest that they approach the findings report in a methodical and scaled approach. The initial step is to categorize the findings based on severity level. Categorizing by severity will be different for each client. There isn't a one size fits all when evaluating risk levels. The only way to do this is to understand the value of the data elements being protected, this includes monetary and non-monetary values. The next step will be to determine the complexity to mitigate the vulnerability and the cost to implement. These steps will help with identifying the actual risk levels, which will determine if the risk is at a point to correct or accept the risk."
        },
        {
          "type": "paragraph",
          "text": "Breaking down the findings using this approach will help create a Plan Of Action & Milestones (POAM) to track the progress in mitigation. It also helps create a sense that correcting the findings are not out of the realm of possibility. The goal is to work WITH your partners and provide the guidance needed after the assessment is completed so they realize that implementing a proper Security Program after an assessment is complete is important but also takes time if done properly."
        },
        {
          "type": "paragraph",
          "text": "If you have any questions, please contact Slate at info@slateenclave.com or 410-989-1102 . Our team is here to help."
        }
      ]
    },
    {
      "id": 751,
      "type": "post",
      "title": "The Role of Cyber Awareness in the Workplace",
      "path": "/the-role-of-cyber-awareness-in-the-workplace",
      "slug": "the-role-of-cyber-awareness-in-the-workplace",
      "parent": 0,
      "date": "May 13, 2020",
      "description": "Mitigating threats of a cyber attack is done by properly educating your employees with how to identify a potential attack.",
      "hero": "/assets/slateheaderimage.png",
      "images": [],
      "blocks": [
        {
          "type": "paragraph",
          "text": "Mitigating threats of a cyber attack is done by properly educating your employees with how to identify a potential attack. Using a Phishing Attack as an example, if you have not implemented an effective training program, potential attacks will continue to exploit weaknesses and run a successful campaign against the organization."
        },
        {
          "type": "paragraph",
          "text": "A proper awareness campaign will include a proper insider threat program. This doesn’t mean that employees are purposefully acting as an insider threat but could be an unknowing participant in the targeted campaign. The majority of breaches affecting organizations involve employees who do not have the education needed to thwart these attacks."
        },
        {
          "type": "paragraph",
          "text": "There is no silver bullet in preventing these types of attacks. Organizations must implement a multi-layer approach which incorporates technical controls with a properly designed training program. There are many tools that can be incorporated to assist with blocking potential threats, but it must be paired with a tailored training program so employees are aware of the types of threats their organization faces. It will teach them how to identify a threat and what to do in the event that a targeted attack occurs."
        },
        {
          "type": "paragraph",
          "text": "These training programs are not a one size fits all, for example, annual training could be split into monthly email modules. Also, they could provide insightful games that help teach what a threat looks like and how to identify it. Until organizations move from a check the box approach to training and move into insightful and comprehensive content, these attacks will continue to occur…"
        }
      ]
    },
    {
      "id": 740,
      "type": "post",
      "title": "CyberSecurity Threats Web Panel",
      "path": "/cybersecurity-threats-web-panel",
      "slug": "cybersecurity-threats-web-panel",
      "parent": 0,
      "date": "May 2, 2020",
      "description": "Slate had the honer of being part of a cyber panel discussing the threat landscape during this Pandemic.",
      "hero": "/assets/slateheaderimage.png",
      "images": [],
      "blocks": [
        {
          "type": "paragraph",
          "text": "Slate had the honer of being part of a cyber panel discussing the threat landscape during this Pandemic. Make sure to take some time out and watch our recommendations to minimize your security footprint..."
        }
      ]
    },
    {
      "id": 729,
      "type": "post",
      "title": "The Importance of Partnerships in Cyber Security",
      "path": "/the-importance-of-partnerships-in-cyber-security",
      "slug": "the-importance-of-partnerships-in-cyber-security",
      "parent": 0,
      "date": "April 3, 2020",
      "description": "There isn’t any single person or company knows everything…. If they claim that they do, find another firm to assist in your path to a stable and healthy security posture.",
      "hero": "/assets/slateheaderimage.png",
      "images": [],
      "blocks": [
        {
          "type": "paragraph",
          "text": "There isn’t any single person or company knows everything…. If they claim that they do, find another firm to assist in your path to a stable and healthy security posture. Throughout the years in this field, I have seen and worked on a lot of programs within a vast array of markets. As Slate grew our consulting practices, we realized that our ability to provide proficient Security Services, from vCISO, Compliance Audits, PenTesting, Engineering Support, etc…, was based on a support structure with industry partners."
        },
        {
          "type": "paragraph",
          "text": "As we sat back and reflected on this realization, we truly understood the value of these partnerships. These relationships have been cultivated through years of trust and collaboration on different projects. With these periodic discussions and partner projects, growth and new ways of implementing a control, tool or “widget” is explored. This does not happen in a silo. There is no real viable way for a small organization is accomplish everything on their own – and why would they? If we help and support each other, we all win and grow with longevity. The result is not just one organization expanding, but multiple organizations growing and learning from each other."
        },
        {
          "type": "paragraph",
          "text": "Who knows… it may even result in friendships that include cigar and scotch while having discussions on new markets to enter or products to bring online. With our Security Services… we added two partners that we reach out to when customers have specific needs that we cannot fill…."
        },
        {
          "type": "paragraph",
          "text": "Epoch, Inc. TheEpochTeam.com MSP/MSSP"
        },
        {
          "type": "paragraph",
          "text": "Atlantic Data Forensics AtlanticDF.com Digital Forensics"
        }
      ]
    },
    {
      "id": 711,
      "type": "post",
      "title": "Teleworking Securely and Safely",
      "path": "/teleworking-securely-and-safely",
      "slug": "teleworking-securely-and-safely",
      "parent": 0,
      "date": "March 31, 2020",
      "description": "As we move to what seems to be a semi-permanent Remote Workforce due to the recent health scare, CISOs and Security Teams are trying to keep up with the change that occurring at a very fast pace.",
      "hero": "/assets/slateheaderimage.png",
      "images": [],
      "blocks": [
        {
          "type": "paragraph",
          "text": "As we move to what seems to be a semi-permanent Remote Workforce due to the recent health scare, CISOs and Security Teams are trying to keep up with the change that is occurring at a very fast pace. Our job in cybersecurity is to reduce the Cyber Threats as much as possible, while continuing to enable day to day business processes and this new trend is pushing customers into a place that they were not setup to accommodate."
        },
        {
          "type": "paragraph",
          "text": "What we have found during our Baseline Audits and Security Program deployments is a large amount of organizations state that they have the appropriate Policies, Procedures and Technical Controls in place, but the opposite seems to be more accurate. In most cases, policies are stale, the procedures that are in place are not relevant due to the constant changes within the infrastructure and no real test of the technical controls are in place to validate they are working."
        },
        {
          "type": "paragraph",
          "text": "So... How does this relate to our ever-changing work environment? This is the time to validate the Security Policies and Procedures that SHOULD have been put in place are working as intended. If your organization has never adopted a remote access policy, it is imperative that it is created. Your organization must adopt the right security strategy so the remote workers can perform their business tasks and stay productive while at the same time reducing the risk of cyber-attacks."
        },
        {
          "type": "paragraph",
          "text": "As your organization is looking to implement Remote Telework Policies, make sure to take these suggestions into account:"
        },
        {
          "type": "list",
          "items": [
            "Prevent the use of personally owned devices. If a personally owned device has been approved for use, do not access NON work-related web sites or store organizational data elements locally. Personal devices often lack the tools built into business networks such as strong antivirus software, customized firewalls, and automatic online backup tools. This increases the risk of malware finding its way onto devices and both personal and work-related information being leaked.",
            "Verify that all AV and Anti-Malware definitions are up to date.",
            "Verify all patches have been applied. If the remote user is connecting with a VPN Client, sandbox the end device until patches and definitions can be validated. Once complete, then allow access to the approved resources.",
            "Only connect to Private or Secured WiFi Access Point. Unsecured public WiFi networks are prime spots for malicious parties to spy on internet traffic and collect confidential information.",
            "When available – encrypt ALL data that is being developed or worked on.",
            "Screen Lock portable devices when not in use – hopefully this is automated with proper GPOs.",
            "If possible – attach a physical lock to the laptop while unintended.",
            "Be vigilant regarding Phishing campaigns. It is highly likely there will be an increase in malicious campaigns targeting remote workers. Do not click on web links within emails from unknown senders.",
            "Use Private VPNs when connecting to sensitive and private networks.",
            "Enforce Multi-Factor Authentication. This will provide an additional level of security in case user credentials have been compromised."
          ]
        },
        {
          "type": "paragraph",
          "text": "As always – Slate is always a phone call or email away assisting our partners with any security concern. If you require assistance or would like to discuss these in more detail, please reach out!"
        }
      ]
    },
    {
      "id": 699,
      "type": "post",
      "title": "Identifying Controlled Unclassified Information (CUI)",
      "path": "/identifying-controlled-unclassified-information-cui",
      "slug": "identifying-controlled-unclassified-information-cui",
      "parent": 0,
      "date": "September 22, 2019",
      "description": "If your organization works on a government contract, you must comply with the Defense Federal Acquisition Regulation Supplement (DFARS).",
      "hero": "/assets/slateheaderimage.png",
      "images": [],
      "blocks": [
        {
          "type": "paragraph",
          "text": "If your organization works on a government contract, you must comply with the Defense Federal Acquisition Regulation Supplement (DFARS). When following the security controls within NIST’s SP 800-171, you must report your level of compliance to the government. This became a requirement at the end of the 2017 calendar year."
        },
        {
          "type": "paragraph",
          "text": "It may seem overwhelming but if you can identify Controlled Unclassified Information (CUI), it will help with mapping out how your organization will satisfy the identified security controls. You must first determine if your organization is even in scope. If the organization holds a federal contract, then you must comply with SP 800-171. You can review this website to help identify the type of data elements that are covered."
        },
        {
          "type": "paragraph",
          "text": "After the determination has been made the organization is required to comply, you will need to identify where the data lives and if it has been tagged and controlled. This step is critical and will help drive the roadmap to being successful with protecting the data that has been identified."
        },
        {
          "type": "paragraph",
          "text": "Once the data is located and tagged, you will need to evaluate whether the data is monitored, audited, alerts are setup to track the location and path of your data elements. You will then identify whether the appropriate controls are in place from the technical evaluation. Your organization will evaluate each control listed within the fourteen (14) families that have been identified as a requirement. This gap analysis will provide a delta of what controls are deficient and which ones are satisfied."
        },
        {
          "type": "paragraph",
          "text": "Following these first three steps will help with the initial evaluation and provide the initial information required to help your organization. Taking the time at the start of this project and making sure that the data is properly identified will help when implementing additional security controls. If your organization skips the crucial first steps, you may incorrectly identify controls as being deficient when they are actually implemented properly; then finding yourself with competing security controls."
        },
        {
          "type": "paragraph",
          "text": "Please reach out with any questions and let us help with your DFARS assessments! Remember, Slate is a Qualified Maryland Cyber Seller – providing tax credits to small businesses."
        },
        {
          "type": "paragraph",
          "text": "Resources:"
        },
        {
          "type": "paragraph",
          "text": "https://www.archives.gov/cui/registry/category-list"
        }
      ]
    },
    {
      "id": 688,
      "type": "post",
      "title": "Starting A Cyber Awareness Program…",
      "path": "/starting-a-cyber-awareness-program",
      "slug": "starting-a-cyber-awareness-program",
      "parent": 0,
      "date": "August 14, 2019",
      "description": "Our staff, as a whole, is our weakest link when it comes to the security posture of the organization.",
      "hero": "/assets/slateheaderimage.png",
      "images": [],
      "blocks": [
        {
          "type": "paragraph",
          "text": "Our staff, as a whole, is our weakest link when it comes to the security posture of the organization. It is our staff that lets their guard down due to workload and it is our staff that configures and deploys our information systems across the enterprise. Most people think that our IT Department is the most critical component of the Cyber Awareness Component, but even with the most comprehensive security measures in place, a quick mishap with a user providing credentials via a phishing attack is enough to circumvent those measures."
        },
        {
          "type": "paragraph",
          "text": "Having a successful Cyber Awareness Training session involves the whole organization, and it starts from the C-Suite buy in. If you do not have the C-Suite buy in and support, then your staff will also feel that the program is not necessary. Show the C-Suite the importance with statistics on the benefits, then you will have their buy in and support – it will go a long way in having the rest of the staff understand the importance of it."
        },
        {
          "type": "paragraph",
          "text": "When developing a program, having short, concise and focused content keeps the end users interested in the content and promotes discussion. The content does not have to be in the form of videos that are an hour long with quizzes at the end. You can have short videos with discussions at the end of each one – making the content engaging while promoting discussion. The goal is to keep it as creative and informative while making the staff feel like they are part of the solution. This will also provide the ability to update the training more frequently, keeping it up to date since it has a more fluid approach as new topics come up during the discussion."
        },
        {
          "type": "paragraph",
          "text": "One final thought on Cyber Training – make sure that you discuss Physical Security. Threats do not just come in the form of electronic/digital. Physical security plays an equally important role in protecting your organization. Having discussions about leaving devices logged in, documents with sensitive information open to public view and how to properly destroy documents are just a few examples that can be discussed."
        },
        {
          "type": "paragraph",
          "text": "As always, Slate is here to help you and your organization navigate these waters and promote awareness in an efficient and positive way. Reach out to us and we can discuss your organizations Cyber Awareness needs…"
        }
      ]
    },
    {
      "id": 685,
      "type": "post",
      "title": "Metrics with a purpose...",
      "path": "/metrics-with-a-purpose",
      "slug": "metrics-with-a-purpose",
      "parent": 0,
      "date": "June 22, 2019",
      "description": "Many executives receive a great deal of data from CSO’s but the majority of instance, they are based on compliance rules put forth in the organization.",
      "hero": "/assets/slateheaderimage.png",
      "images": [],
      "blocks": [
        {
          "type": "paragraph",
          "text": "Many executives receive a great deal of data from CSO’s but the majority of instance, they are based on compliance rules put forth in the organization. While it is important to know the completeness of these controls, those metrics can be difficult for the executive team to quantify or fully understand how they relate to their security posture. Adherence to these rules and technical controls are very important and should be maintained, but if an event or disaster occurs, compliance data elements do not help with recovery or posture."
        },
        {
          "type": "paragraph",
          "text": "We still suggest tracking common and important metrics, such as vulnerability scans, patch status, compliance metrics, etc… but CSO’s should emphasize certain data elements which provide the executive team a deeper understanding of their security posture. Implementing and maintaining a valid baseline maturity model is the first step in provide real information to your executives. If you just show data from a graph that states how many attack attempts were blocked, then your executive team will assume that everything is still fine – until the first weakness is exploited. These metrics need to show relevance and most executives will not know what to do with the report without any context. Taking the metrics, you are gathering and then creating a maturity model based on that data provides insight to the security program and if progress is being made."
        },
        {
          "type": "paragraph",
          "text": "There are multiple security maturity models to choose from and implement so there is no need to reinvent the wheel. Choose the one that fits your type of organization and tweak that one as needed. At the simplest design – you want to move from a Reactive style maturity level and implement the appropriate Compliance driven controls, such as mandatory regulatory overlays, and then finally move into a Risk Based maturity level where your organization is proactively correctly security deficiencies."
        },
        {
          "type": "paragraph",
          "text": "These models and the components within them will vary from boardroom to boardroom. Some executives care deeply and understand the struggles that may be occurring within the security department while others have very little interest. CSOs must build relationships and have thoughtful conversations so they can develop the appropriate maturity model. Making sure that these reports capture the correct data elements that each business unit cares about is vital so the executives can provide informed business decisions."
        }
      ]
    },
    {
      "id": 681,
      "type": "post",
      "title": "The Long-Term Approach for Security Programs",
      "path": "/the-long-term-approach-for-security-programs",
      "slug": "the-long-term-approach-for-security-programs",
      "parent": 0,
      "date": "June 9, 2019",
      "description": "As Slate continues to grow as a trusted partner with our clients, it has become evident that most organizations are looking for the “check the box” approach.",
      "hero": "/assets/slateheaderimage.png",
      "images": [],
      "blocks": [
        {
          "type": "paragraph",
          "text": "As Slate continues to grow as a trusted partner with our clients, it has become evident that most organizations are looking for the “check the box” approach. In most cases, it is not due to the organization trying to just get by with the minimum required actions, but rather their lack of knowledge with what is required for organizations to comply with. The breadth of knowledge needed to fully understand the changing landscape of regulatory compliance that organizations are forced to meet is quite vast."
        },
        {
          "type": "paragraph",
          "text": "When we are asked to come into an organization and provide pricing for a specific project, we always take a step back and engage in a full discussion to determine their true needs. A hand full of times, the project will change direction once the client understands what regulatory and family of controls they are trying to satisfy. We typically ask customers if they have a Security Program in place and if they do, how often is it maintained and adjusted based on their business needs. Most of the responses we receive fall into the category of “No Security Program”. Once we see that they lack the basic security management, we work to provide a long-term approach to implementing a Security Program that aligns with their business needs. After a stable and mature security program is in place, it is at that point where we can provide quick reaction type audits or penetration tests, which help satisfy the controls AND assist with validating our Security Program is functioning as intended."
        },
        {
          "type": "paragraph",
          "text": "This approach, the long reach, is based on our firm building a long-term relationship with each client that we engage. It is our belief that security firms should become part of the client’s business functions. Taking the time to fully understand the business needs and functions of the client is the only way a proper security program can be developed and deployed. Skipping the evaluation portion will create havoc while deploying a security program since it will not align with the business functions. The misaligned security program can potentially cause issues with day to day operations, which can cost the client financial strain."
        },
        {
          "type": "paragraph",
          "text": "The long-term approach that we have developed, with our first 100 days framework, is in the heart of Slate’s vCISO program. We have developed this system with our client’s best interest in mind – as the tag line states, we are exceeding your expectations, while enhancing your security posture…"
        },
        {
          "type": "paragraph",
          "text": "Make sure to reach out and see how we can help…"
        }
      ]
    },
    {
      "id": 674,
      "type": "post",
      "title": "A Refresher on the Necessity of the Virtual CISO",
      "path": "/a-refresher-on-the-necessity-of-the-virtual-ciso",
      "slug": "a-refresher-on-the-necessity-of-the-virtual-ciso",
      "parent": 0,
      "date": "May 14, 2019",
      "description": "Verizon has just published their annual Data Breach Report. The report was written by compiling data from 41,686 security incidents and 2,013 data breaches.",
      "hero": "/assets/slateheaderimage.png",
      "images": [],
      "blocks": [
        {
          "type": "paragraph",
          "text": "Verizon has just published their annual Data Breach Report. The report was written by compiling data from 41,686 security incidents and 2,013 data breaches. Verizon was able to isolate specific data points from the compiled data, giving organizations the ability to know where they should focus their attention. They found that even though most attacks originated from outside sources, internal threats, such as employees comprised of 34% of the attacks, which is up from 28% in 2018. Another increased data point is the involvement of Nation State Actors, which is at 28%, up from 12%. One staggering statistic is that 43% of the attacks involved small businesses. These increases are clear indicators that attacks are becoming more sophisticated and financially motivated."
        },
        {
          "type": "paragraph",
          "text": "Small to Medium Businesses have typically ignored the necessity of the CISO in their organization, either based on the cost or their assumption that one is not needed. As noted from the Verizon Breach Report, this is furthest from the truth. Now, as regulatory and contractual compliance becomes a requirement for organizations, it is imperative that these companies get ahead of these requirements. Playing catch up by baking the required Security Controls into their business processes becomes a very costly endeavor."
        },
        {
          "type": "paragraph",
          "text": "Having a qualified CISO on staff to assist your organization can be costly. The average base salary of a CISO is approximately $185,000 and if you add the overhead costs it could drive the true cost upwards of $250,000. Slate has developed a framework that provides the services of a CISO at a fractional cost. We start with the assessment of the organization, then develop and design the appropriate Security Program that works with YOUR organization. We understand that not all organizations are the same, neither should your security program. After the design of the program, Slate will execute the program and start developing reporting modules so each business unit can evaluate their metrics. The metrics will also provide each business unit the data needed to adjust their program and fine tune their security controls."
        },
        {
          "type": "paragraph",
          "text": "Do Not Forget – Slate Enclave is a Qualified Maryland Cyber Company . Find out how we can assist you in potentially getting up to 50% of our services covered under the Maryland Tax Credit."
        },
        {
          "type": "paragraph",
          "text": "SOURCES"
        },
        {
          "type": "paragraph",
          "text": "Verizon 2018 Data Breach Investigation Report - https://enterprise.verizon.com/resources/reports/DBIR_2018_Report_execsummary.pdf"
        },
        {
          "type": "paragraph",
          "text": "Verizon 2019 Data Breach Investigations Report - https://enterprise.verizon.com/resources/executivebriefs/2019-dbir-executive-brief.pdf"
        }
      ]
    },
    {
      "id": 663,
      "type": "post",
      "title": "Cyber Insurance – Needed???",
      "path": "/cyber-insurance-needed",
      "slug": "cyber-insurance-needed",
      "parent": 0,
      "date": "February 16, 2019",
      "description": "A few weeks ago, I had recommended to a client that they should purchase Insurance instead of implementing specific controls in their environment to mitigate risk.",
      "hero": "/assets/slateheaderimage.png",
      "images": [],
      "blocks": [
        {
          "type": "paragraph",
          "text": "A few weeks ago, I had recommended to a client that they should purchase Insurance instead of implementing specific controls in their environment to mitigate a particular risk. The client was not aware that this was an option and thought that General Liability Insurance provided coverage. Once I explained that liability insurance is very limited and can protect from financial losses, it does not cover cyber related incidents."
        },
        {
          "type": "paragraph",
          "text": "Deciding if Cyber Insurance is needed requires a bit of time to evaluate the data asset and calculate the potential for the threat to be realized (does anyone remember the risk equation?). Once those variables are determined and calculated, a value for Risk is achieved. It showed that the cost to implement the control was greater than the cost of transferring the risk to the insurance company. Now… this isn’t the only thing to consider when determining if Insurance should be purchased. A couple of examples are – small to mid-size companies are bound by third party audits or the company handles sensitive information. It will take a bit of time to determine if purchasing Cyber Insurance is right for your organization but there is a benefit that isn’t always quantifiable at first, but it has a huge impact on business – name recognition and reputation. Can your company recover from a tarnished reputation?"
        },
        {
          "type": "paragraph",
          "text": "Once the determination that Cyber Insurance is needed to cover items that may not be feasible to mitigate in house for what ever reason, the next step would be to consider what type of insurance is needed. At this point, it is highly recommended that you engage with an Insurance Broker that can assist with this question. Each company has different needs and requirements, cyber coverage can include things such as data loss, extortion, theft, breeches and denial of service attacks. Having them walk through the process will make sure proper coverage is obtained. Improperly filling out the questionnaires can lead to not having enough coverage if a breech occurs. A trustworthy broker can help navigate these questions while advocating on your behalf for the best package."
        },
        {
          "type": "paragraph",
          "text": "Once the policy is in place, make sure that your company is performing their Due Diligence when protecting the assets. If an incident occurs and the Insurance Company determines that the company did not meet the minimum requirements in protecting the data, the claim can be denied."
        }
      ]
    },
    {
      "id": 657,
      "type": "post",
      "title": "Slate Enclave - Now a Qualified Maryland Cybersecurity Company",
      "path": "/slate-enclave-now-a-qualified-maryland-cybersecurity-company",
      "slug": "slate-enclave-now-a-qualified-maryland-cybersecurity-company",
      "parent": 0,
      "date": "February 1, 2019",
      "description": "We are pleased to announce that Slate Enclave has been certified by MD Department of Commerce as a Qualified Maryland Cybersecurity Company (QMCC).",
      "hero": "/assets/slateheaderimage.png",
      "images": [],
      "blocks": [
        {
          "type": "paragraph",
          "text": "We are pleased to announce that Slate Enclave has been certified by MD Department of Commerce as a Qualified Maryland Cybersecurity Company (QMCC). Having this designation allows Maryland companies to work with us while developing a Cybersecurity Program for their company while having the opportunity to claim up to $50,000 in tax credits during the same year."
        },
        {
          "type": "paragraph",
          "text": "Contact us by phone or email to discuss this great opportunity further..."
        },
        {
          "type": "paragraph",
          "text": "Office Number – (410) 989-1102 Email – info@slateenclave.com"
        }
      ]
    },
    {
      "id": 654,
      "type": "post",
      "title": "Vulnerability Scanning – The Tool That Keeps On Giving",
      "path": "/vulnerability-scanning-the-tool-that-keeps-on-giving",
      "slug": "vulnerability-scanning-the-tool-that-keeps-on-giving",
      "parent": 0,
      "date": "January 21, 2019",
      "description": "We have recently seen an increase in customers asking if performing vulnerability scans is necessary in an era where patching can be automated.",
      "hero": "/assets/slateheaderimage.png",
      "images": [],
      "blocks": [
        {
          "type": "paragraph",
          "text": "We have recently seen an increase in customers asking if performing vulnerability scans is necessary in an era where patching can be automated at the host or by using patch management tools. The short answer is YES! Each environment is its own animal and the possibility of an organization being compromised rises at a high rate when they are not sure of what potential vulnerabilities lurk within each system."
        },
        {
          "type": "paragraph",
          "text": "When performing vulnerability scans against the systems in your organizations, you get a complete look at potential vulnerabilities that exist which may not be resolved by just applying a patch. Some require a customized approach where a hands-on change to a system is required. Take, as an example, software applications that install services which can run encrypted and unencrypted communication channels. Many applications, by default, will install both services and allow the end user to configure which communication port/service to run on. This method doesn’t mean the software isn’t patched BUT the vulnerability scanner would flag this as an issue while the Patch Management system will not flag this as an issue."
        },
        {
          "type": "paragraph",
          "text": "Vulnerability scanners should also be used to validate that your patch management program is applying the appropriate patches. If your organization relies on the patch program to report that the patches were distributed, you could miss that a device didn’t have the patch applied correctly. This scenario happens quite often in organizations which have devices that do not behave properly. A checks and balances toward each system in place is a great way for your organization to remain compliant regarding any type of regulatory requirement that your business line must adhere to."
        },
        {
          "type": "paragraph",
          "text": "Attackers are constantly sweeping for vulnerable ports, services and applications since most organizations will typically not have everything patched and configured in a hardened state. Performing these scans on a routine basis, at least quarterly and hopefully monthly, will help lower the potential risk of a breach occurring. With the ability to automate these scans and generate reports on the findings, it really doesn’t require a large commitment of time or effort."
        },
        {
          "type": "paragraph",
          "text": "Another example of the usefulness of vulnerability scanning comes with the ability to scan for rogue devices that may be plugged into the environment. These rogue devices could be placed there for many reasons – from employees using personal devices to malicious access points placed on the network for unauthorized access. Whatever the reason, a scan can help identify these devices on the network."
        },
        {
          "type": "paragraph",
          "text": "As hackers continue to look for vulnerabilities while creating malware, it is imperative that organizations take steps to minimize the threat they impose. Running these types of vulnerability scans against the environment can help with by providing a snapshot of the infrastructure’s security posture."
        }
      ]
    },
    {
      "id": 647,
      "type": "post",
      "title": "The Case for Authorized Application Lists",
      "path": "/the-case-for-authorized-application-lists",
      "slug": "the-case-for-authorized-application-lists",
      "parent": 0,
      "date": "January 12, 2019",
      "description": "An Authorized Application List, or Whitelisting Applications is a method to approve applications for enterprise use.",
      "hero": "/assets/slateheaderimage.png",
      "images": [],
      "blocks": [
        {
          "type": "paragraph",
          "text": "An Authorized Application List, or Whitelisting Applications is a method to approve applications for enterprise use if the business need exists while controlling and validating the source of the applications. If the application is not on the authorized list, it cannot be installed on the end device. An exception can be submitted and reviewed for approval by the Senior Leadership of the Organization."
        },
        {
          "type": "paragraph",
          "text": "This control may seem simple and low risk, but with the increased use of mobile devices, mobile applications have increasingly been used to scrub sensitive information from the mobile device, which increases the necessity of implementing and satisfying this security control. Applications are gaining access to the sensitive data for multiple reasons, it helps focus their marketing of products, the data can be sold to third party organizations for profit or used to install malware directly onto the device. These are just a few examples but many more exist. Be mindful of the “free” applications as well – if there isn’t a direct cost for the application, there is a high probability you become the product for their third-party partners. These examples have focused on personal data on the mobile device, such as contacts or web habits, but if the applications have access to storage areas, they can also scrub sensitive business information as well."
        },
        {
          "type": "paragraph",
          "text": "An Authorized Applications List or Whitelisting can be implemented and enforced in many ways, but the top-level approach should be a Corporate Policy defining the organizations stance on Authorized and Unauthorized Applications. Once the policy is written and authorized by the senior leadership of the organization, a procedure is written which allows all personnel involved with the ability to follow a repeatable process of evaluating the software. The list can be as simple as an Excel Spreadsheet to a fully deployed security suite that will evaluate if rogue software is trying to be installed and executed on the end device, therefore preventing the process from running. What method is used is not as important as having it defined. Just keep in mind it needs to be evaluated on a periodic basis or it will become out of date and ineffective."
        }
      ]
    },
    {
      "id": 637,
      "type": "post",
      "title": "The virtual CISO… What are the benefits",
      "path": "/the-virtual-ciso-what-are-the-benefits",
      "slug": "the-virtual-ciso-what-are-the-benefits",
      "parent": 0,
      "date": "November 15, 2018",
      "description": "As the demand grows for vCISO services, it is getting more difficult to find a candidate who has the appropriate level of experience needed to fill that gap.",
      "hero": "/assets/slateheaderimage.png",
      "images": [],
      "blocks": [
        {
          "type": "paragraph",
          "text": "As the demand grows for vCISO services, it is getting more difficult to find a candidate who has the appropriate level of experience needed to fill that gap. This issue of supply and demand is getting worse as the number of security incidents rise each year. These changes within the Information Security space is causing organizations to rethink the necessity of implementing a proper security program, which is driving the competitive market for these specialized services."
        },
        {
          "type": "paragraph",
          "text": "Implementing a virtual CISO program can help fill that gap and really show the value to the organization that requires it. Organizations can obtain the expertise needed to fill the gap while enhancing their security posture. This can be done without increasing their head count or overhead. A large portion of organizations do not need to hire a full time CISO, they only require the independent and unbiased views needed to guide the organization into a more secure state."
        },
        {
          "type": "paragraph",
          "text": "There are great advantages to utilizing a vCISO, as mentioned previously, not hiring a full-time person can reduce the cost in terms of salary and benefits provided. The cost of a vCISO typically falls to about 40 percent of the standard industry salary, greatly alleviating the pressure to small and mid-size companies. They also provide specialized knowledge that internal IT Staff will not have. They can incorporate the experience in regulatory compliance and security while the IT Staff focus on their day to day operations. One over looked aspect of bringing a virtual CISO on board is the vendor agnostic view they hold. Since the vCISO is experienced in multiple industries, they typically have no agenda and tend to just complete the job of implementing a proper security program. They tend to look at their goals from an Independent View."
        },
        {
          "type": "paragraph",
          "text": "Those are just a few of the benefits of implementing a vCISO within your organization. Having the ability to tailor your requirements of the vCISO to your needs will make sure that you are getting the most value possible."
        }
      ]
    },
    {
      "id": 634,
      "type": "post",
      "title": "Navigating Breach Notification Requirements",
      "path": "/navigating-breach-notification-requirements",
      "slug": "navigating-breach-notification-requirements",
      "parent": 0,
      "date": "October 13, 2018",
      "description": "Today’s business climate involves constant cyber-attacks against all types of organizations, regardless of industry.",
      "hero": "/assets/slateheaderimage.png",
      "images": [],
      "blocks": [
        {
          "type": "paragraph",
          "text": "Today’s business climate involves constant cyber-attacks against all types of organizations, regardless of industry. Unfortunately, it is an inevitable occurrence that organizations must be prepared to handle. These attacks target organizations that have developed and implemented a proper security program and organizations that have misconfigured and poorly implemented security programs. They are targeting an organization based on the value of the data that they maintain, such as Protected Health Information (PHI) and Personally Identifiable Information (PII). Once the breach occurs, it can result in data exfiltration which requires the Organization to adhere to specific Breach Notification Laws that can be difficult to navigate."
        },
        {
          "type": "paragraph",
          "text": "The organization must first identify what data they manage and contain so they can understand what laws need to be followed based on the industry that is operates within. This step can deal with both federal and state requirements. For example, when handling PHI, Health and Human Services has documented on their website the HIPAA Breach Notification Rule along with how it defines a breach and it provides notification requirements if a breach occurs. These requirements are enforced by the Federal Trade Commission (FTC). These requirements, when dealing with PHI, requires the covered entities to notify affected users within sixty (60) days of identifying that a breach has occurred. The notification period could be shorter business associates, resulting in notifications being sent within a few days. This can be in the form of mail, email or media notices. [1]"
        },
        {
          "type": "paragraph",
          "text": "After looking at the federal requirements, the next step is to evaluate what the state requires for a breach notification. The requirements are not just for the state that the entity has their headquarters, but also includes the laws of the states that they operate in as well. In 2018, Maryland adjusted the Personal Information Protection Act, adding more identifiers to what is considered PII. In the past, the list included items such as SS Numbers, driver’s license numbers, etc. Now the list includes biometric data and health information. [2] Under the Maryland requirements, organizations are required to handle a “Good Faith” investigation to identify if data has been compromised. Notice must be provided as soon as reasonably practicable. This could be delayed if a federal or state investigation is in progress."
        },
        {
          "type": "paragraph",
          "text": "Once the federal and state requirements have been evaluated, identify the gaps and differences to determine which is the stricter of the two. Implement that rule since it would encompass the less binding requirement. A good option is to engage a lawyer in the field of Cyber Law. The lawyer will provide strict guidance on how to handle breach notifications for the specified industry, removing any potential of additional fines or penalties for mis-handling the occurrence."
        },
        {
          "type": "paragraph",
          "text": "Finally, once the required actions are identified for handling a breach, they need to be documented within an Incident Response Plan. The IR Plan should have specific categories, so the organization understands how to handle different types incidents. In the case of handling a breach, it will identify what key players, such as stake holders and insurance policies, are involved to properly identify and isolate the compromised components without affecting the evidence of the breach. Once the IR Plan is in place, it must be run through numerous times to flush out any deficiencies within the plan to minimize the risk of not properly handling a potential breach."
        },
        {
          "type": "paragraph",
          "text": "[1] https://www.hhs.gov/hipaa/for-professionals/breach-notification/index.html"
        },
        {
          "type": "paragraph",
          "text": "[2] http://www.marylandattorneygeneral.gov/Pages/IdentityTheft/businessGL.aspx"
        }
      ]
    },
    {
      "id": 471,
      "type": "post",
      "title": "Is Your Organization DFARS Compliant?",
      "path": "/is-your-organization-dfars-compliant",
      "slug": "is-your-organization-dfars-compliant",
      "parent": 0,
      "date": "August 27, 2018",
      "description": "The Defense Federal Acquisition Regulation Supplement (DFARS) guidance that has been published by the Federal Government requires all DoD contractors and organizations that deal with sensitive data related to government programs complete a NIST 800-171 assessment to become fully compliant with section 252.204-7012.",
      "hero": "/assets/slateheaderimage.png",
      "images": [],
      "blocks": [
        {
          "type": "paragraph",
          "text": "The Defense Federal Acquisition Regulation Supplement (DFARS) guidance that has been published by the Federal Government requires all DoD contractors and organizations that deal with sensitive data related to government programs complete a NIST 800-171 assessment to become fully compliant with section 252.204-7012. If this assessment is not completed and compliant, your organization can risk current and future DoD contracts."
        },
        {
          "type": "paragraph",
          "text": "Many organizations believe that they are not required to adhere to this requirement, but if your organization works with the DoD and stores sensitive controlled unclassified information (CUI), such as technical information, contractual information, drawings, etc… on your corporate environment or in a government approved cloud then a DFARS audit must be conducted using NIST SP 800-171 as a guide. Newly awarded contracts are containing language stating that organization must be compliant and need to report back to the Federal Government with any deficiencies with the required controls."
        },
        {
          "type": "paragraph",
          "text": "The DFARS set of controls within NIST 800-171 Safeguarding Covered Defense Information and Cyber Incident Reporting contains thirty (30) basic requirements and seventy-nine (79) derived security requirements which map back to NIST 800-53 security controls. This could be viewed as a simplified FISMA Audit so if your organization has already conducted a FISMA Audit, chances are good that you will most likely pass the controls which are in selected in the DFARS Audit. The goal of the audit is to evaluate two core security families – 1) Adequate Security and 2) Incident Reporting. The Adequate Security family of controls is designed to ensure that all sensitive information is protected in a manner that has either mitigated or lowered the risk of exposure. The Incident Reporting family of controls is designed to ensure that your organization has the proper Incident Handling steps in place to make sure that the identification and handling of incidents occur, whether they are actual intrusions or even attempted intrusions against the environment."
        },
        {
          "type": "paragraph",
          "text": "Your obligation does not end at the audit and assessment phase of the DFARS process. If any control fails to be compliant, the organizations must report the deficiency within 30 days after the contract award with a plan of action for how the control will be mitigated or why it hasn’t been corrected. When a potential incident does occur, or an attempt has occurred, the organization must report within 72 hours after the identification of the incident. It has become clear that the federal and local governments are not taking a relaxed approach to vendors who are entrusted with sensitive information that could affect programs that are current along with programs that will deploy soon."
        }
      ]
    },
    {
      "id": 469,
      "type": "post",
      "title": "How to approach your first security audit!",
      "path": "/how-to-approach-your-first-security-audit",
      "slug": "how-to-approach-your-first-security-audit",
      "parent": 0,
      "date": "August 27, 2018",
      "description": "Having an audit conducted on your organization’s security program is not an event that most people look forward to.",
      "hero": "/assets/slateheaderimage.png",
      "images": [],
      "blocks": [
        {
          "type": "paragraph",
          "text": "Having an audit conducted on your organization’s security program is not an event that most people look forward to. They are filled with auditors who make a living trying to find deficiencies and weaknesses in the implemented, or not implemented, controls that are part of your industry. Multiple triggers can push the audit, but two of the common triggers are - 1) business associate/partner could require it if the organization is retaining their data or 2) federal mandates and laws require it. These audits can range from an initial shadow audit where the organization is looking to gain a high-level understanding of their security posture, to a full assessment where each control is evaluated based on the security categorization of the organization. The organization’s level of maturity will determine which approach they will take."
        },
        {
          "type": "paragraph",
          "text": "Most mid-level organizations are new to the requirement of having an audit performed against their information systems. The Auditors will evaluate more than just the technical implementation of the controls, they will verify that there is a policy and procedure associated with each control. In their eyes – if the control isn’t documented or audited, then it is not implemented. Our biggest push to our clients is to make them understand that everything must be repeatable and auditable."
        },
        {
          "type": "paragraph",
          "text": "If the organization has not performed an audit in the past, we always recommend that the organization select a subset of the controls which have been identified as applicable and perform a self-assessment. If they cannot perform this task, due to time or resource constraints, we are able to come in and assist with this Shadow Audit. This will give your organization a score card and baseline that your security team and system owners can work from. Having this baseline will provide a starting point with a small set of controls which doesn’t overwhelm the engineers or management team when trying to understand how to approach a full audit containing over eight hundred controls that may have failed or passed."
        },
        {
          "type": "paragraph",
          "text": "Starting small and working into the full audit is a reasonable approach and will also show the auditors that the organization is performing its due diligence in creating a proper security program that will ultimately lower its level of risk. Once completed, the organization can then grab a next set of controls and work on mitigating or lowering their risk against each business unit. The goal is to lower risk to a manageable level but if the wrong approach is taken, the chances are high that none of the controls will be satisfied."
        }
      ]
    }
  ],
  "latestPosts": [
    {
      "title": "The Top Metrics to Track in Cybersecurity",
      "path": "/the-top-metrics-to-track-in-cybersecurity",
      "description": "If you are a federal government contractor, you are preparing your organization for the Cybersecurity Maturity Model Certification (CMMC). The United States Departme",
      "date": "October 16, 2021",
      "hero": "/assets/Untitled-design.jpg"
    },
    {
      "title": "The New CMMC Controls for Security Awareness and Training",
      "path": "/the-new-cmmc-controls-for-security-awareness-and-training",
      "description": "If you are a federal government contractor, you are preparing your organization for the Cybersecurity Maturity Model Certification (CMMC). The United States Departme",
      "date": "July 27, 2021",
      "hero": "/assets/Untitled-design-14.png"
    },
    {
      "title": "The Benefits of Hiring a Virtual CISO",
      "path": "/the-benefits-of-hiring-a-virtual-ciso",
      "description": "Our day-to-day lives have become so busy, that we often forget to maintain and update passwords unless it is forced upon us by third-party applications or corporate ",
      "date": "June 16, 2021",
      "hero": "/assets/Untitled-design-2-1.png"
    },
    {
      "title": "How Password Managers Help Secure Your Information Online",
      "path": "/how-password-managers-help-secure-your-information-online",
      "description": "Our day-to-day lives have become so busy, that we often forget to maintain and update passwords unless it is forced upon us by third-party applications or corporate ",
      "date": "May 12, 2021",
      "hero": "/assets/Untitled-design-12.png"
    },
    {
      "title": "10 Ways to Secure Your Remote Workforce",
      "path": "/10-ways-to-secure-your-remote-workforce",
      "description": "Almost one year has passed since COVID-19 changed our daily lives, from how we interact with friends and family to how we conduct our daily work efforts. Over this t",
      "date": "March 4, 2021",
      "hero": "/assets/Copy-of-Untitled.png"
    }
  ],
  "media": [
    {
      "id": 1598,
      "title": "natalie",
      "source": "/assets/natalie.png",
      "alt": "natalie"
    },
    {
      "id": 1164,
      "title": "Untitled design",
      "source": "/assets/Untitled-design.jpg",
      "alt": "Untitled design"
    },
    {
      "id": 1136,
      "title": "Untitled design",
      "source": "/assets/Untitled-design-14.png",
      "alt": "Untitled design"
    },
    {
      "id": 1124,
      "title": "Untitled design (2)",
      "source": "/assets/Untitled-design-2-1.png",
      "alt": "Untitled design (2)"
    },
    {
      "id": 1121,
      "title": "Untitled design",
      "source": "/assets/Untitled-design-13.png",
      "alt": "Untitled design"
    },
    {
      "id": 1100,
      "title": "Untitled design",
      "source": "/assets/Untitled-design-12.png",
      "alt": "Untitled design"
    },
    {
      "id": 1058,
      "title": "Copy of Untitled",
      "source": "/assets/Copy-of-Untitled.png",
      "alt": "Copy of Untitled"
    },
    {
      "id": 1038,
      "title": "Untitled design",
      "source": "/assets/Untitled-design-11.png",
      "alt": "Untitled design"
    },
    {
      "id": 1028,
      "title": "Untitled design",
      "source": "/assets/Untitled-design-10.png",
      "alt": "Untitled design"
    },
    {
      "id": 1002,
      "title": "Untitled design (5)",
      "source": "/assets/Untitled-design-5-1.png",
      "alt": "Untitled design (5)"
    },
    {
      "id": 988,
      "title": "Untitled design",
      "source": "/assets/Untitled-design-9.png",
      "alt": "Untitled design"
    },
    {
      "id": 962,
      "title": "DSC_0733-2",
      "source": "/assets/DSC_0733-2.jpg",
      "alt": "DSC_0733-2"
    },
    {
      "id": 961,
      "title": "DSC_0733",
      "source": "/assets/DSC_0733.jpg",
      "alt": "DSC_0733"
    },
    {
      "id": 881,
      "title": "9",
      "source": "/assets/9-1.png",
      "alt": "9"
    },
    {
      "id": 880,
      "title": "10",
      "source": "/assets/10-1.png",
      "alt": "10"
    },
    {
      "id": 849,
      "title": "Untitled design (8)",
      "source": "/assets/Untitled-design-8.png",
      "alt": "Untitled design (8)"
    },
    {
      "id": 845,
      "title": "10",
      "source": "/assets/10.png",
      "alt": "10"
    },
    {
      "id": 844,
      "title": "11",
      "source": "/assets/11.png",
      "alt": "11"
    },
    {
      "id": 843,
      "title": "12",
      "source": "/assets/12.png",
      "alt": "12"
    },
    {
      "id": 839,
      "title": "Untitled design (7)",
      "source": "/assets/Untitled-design-7.png",
      "alt": "Untitled design (7)"
    },
    {
      "id": 836,
      "title": "Untitled design (6)",
      "source": "/assets/Untitled-design-6.png",
      "alt": "Untitled design (6)"
    },
    {
      "id": 834,
      "title": "7",
      "source": "/assets/7.png",
      "alt": "7"
    },
    {
      "id": 833,
      "title": "8",
      "source": "/assets/8.png",
      "alt": "8"
    },
    {
      "id": 832,
      "title": "9",
      "source": "/assets/9.png",
      "alt": "9"
    },
    {
      "id": 826,
      "title": "Untitled design (5)",
      "source": "/assets/Untitled-design-5.png",
      "alt": "Untitled design (5)"
    },
    {
      "id": 825,
      "title": "Untitled design (4)",
      "source": "/assets/Untitled-design-4.png",
      "alt": "Untitled design (4)"
    },
    {
      "id": 814,
      "title": "1",
      "source": "/assets/1.png",
      "alt": "1"
    },
    {
      "id": 810,
      "title": "2",
      "source": "/assets/2.png",
      "alt": "2"
    },
    {
      "id": 809,
      "title": "3",
      "source": "/assets/3.png",
      "alt": "3"
    },
    {
      "id": 808,
      "title": "4",
      "source": "/assets/4.png",
      "alt": "4"
    },
    {
      "id": 807,
      "title": "5",
      "source": "/assets/5.png",
      "alt": "5"
    },
    {
      "id": 803,
      "title": "SlateLogoFinal",
      "source": "/assets/SlateLogo-Higher-Res.jpg",
      "alt": "SlateLogoFinal"
    },
    {
      "id": 797,
      "title": "Copy of Copy of Copy of Copy of Copy of Copy of Untitled copy",
      "source": "/assets/Copy-of-Copy-of-Copy-of-Copy-of-Copy-of-Copy-of-Untitled-copy.png",
      "alt": "Copy of Copy of Copy of Copy of Copy of Copy of Untitled copy"
    },
    {
      "id": 793,
      "title": "slateheaderimage",
      "source": "/assets/slateheaderimage.png",
      "alt": "slateheaderimage"
    },
    {
      "id": 790,
      "title": "Untitled design (3)",
      "source": "/assets/Untitled-design-3.png",
      "alt": "Untitled design (3)"
    },
    {
      "id": 789,
      "title": "Untitled design (2)",
      "source": "/assets/Untitled-design-2.png",
      "alt": "Untitled design (2)"
    },
    {
      "id": 788,
      "title": "Untitled design (1)",
      "source": "/assets/Untitled-design-1.png",
      "alt": "Untitled design (1)"
    },
    {
      "id": 785,
      "title": "Untitled design",
      "source": "/assets/Untitled-design.png",
      "alt": "Untitled design"
    },
    {
      "id": 777,
      "title": "cropped-Slate-Square-for-LinkedIn-e1595621611620.png",
      "source": "/assets/cropped-Slate-Square-for-LinkedIn-e1595621611620.png",
      "alt": "cropped-Slate-Square-for-LinkedIn-e1595621611620.png"
    },
    {
      "id": 774,
      "title": "Slate Square for LinkedIn",
      "source": "/assets/Slate-Square-for-LinkedIn-e1595621611620.png",
      "alt": "Slate Square for LinkedIn"
    },
    {
      "id": 608,
      "title": "ISC2_logo",
      "source": "/assets/ISC2_logo.png",
      "alt": "(ISC)2 logo"
    },
    {
      "id": 600,
      "title": "iStock-866364868-2",
      "source": "/assets/iStock-866364868-2.jpg",
      "alt": "iStock-866364868-2"
    },
    {
      "id": 597,
      "title": "accomplishment-agreement-business-1249158",
      "source": "/assets/accomplishment-agreement-business-1249158.jpg",
      "alt": "accomplishment-agreement-business-1249158"
    },
    {
      "id": 595,
      "title": "Friends giving high fives",
      "source": "/assets/iStock-884301598.jpg",
      "alt": "Friends giving high fives"
    },
    {
      "id": 594,
      "title": "Creative Designers Using 3D Printer",
      "source": "/assets/iStock-886646974.jpg",
      "alt": "Creative Designers Using 3D Printer"
    },
    {
      "id": 592,
      "title": "866364868-1024x1024r2",
      "source": "/assets/866364868-1024x1024r2.jpg",
      "alt": "866364868-1024x1024r2"
    },
    {
      "id": 591,
      "title": "866364868-1024x1024-r",
      "source": "/assets/866364868-1024x1024-r.jpg",
      "alt": "866364868-1024x1024-r"
    },
    {
      "id": 583,
      "title": "866364868-1024x1024-3",
      "source": "/assets/866364868-1024x1024-3.jpg",
      "alt": "866364868-1024x1024-3"
    },
    {
      "id": 580,
      "title": "866364868-1024x1024-2",
      "source": "/assets/866364868-1024x1024-2.jpg",
      "alt": "866364868-1024x1024-2"
    },
    {
      "id": 576,
      "title": "Abstract blue background of lines and reflections, Business theme",
      "source": "/assets/iStock-816324726-e1536593563643.jpg",
      "alt": "Abstract blue background of lines and reflections, Business theme"
    },
    {
      "id": 572,
      "title": "816324726-1024x1024",
      "source": "/assets/816324726-1024x1024-e1536593394442.jpg",
      "alt": "816324726-1024x1024"
    },
    {
      "id": 565,
      "title": "Conference table closeup",
      "source": "/assets/iStock-649495828-1-e1536590990154.jpg",
      "alt": "Conference table closeup"
    },
    {
      "id": 564,
      "title": "Conference table closeup",
      "source": "/assets/iStock-649495828.jpg",
      "alt": "Conference table closeup"
    },
    {
      "id": 562,
      "title": "Empty, modern, futuristic command center interior",
      "source": "/assets/iStock-506485418.jpg",
      "alt": "Empty, modern, futuristic command center interior"
    },
    {
      "id": 556,
      "title": "dark blue  glass surface",
      "source": "/assets/iStock-507021778.jpg",
      "alt": "dark blue  glass surface"
    },
    {
      "id": 552,
      "title": "Social connections",
      "source": "/assets/iStock-849234128-e1536589839487.jpg",
      "alt": "Social connections"
    },
    {
      "id": 535,
      "title": "INSCOM_SEAL-3",
      "source": "/assets/INSCOM_SEAL-3.png",
      "alt": "INSCOM_SEAL-3"
    },
    {
      "id": 533,
      "title": "Seal_of_the_United_States_Federal_Aviation_Administration",
      "source": "/assets/Seal_of_the_United_States_Federal_Aviation_Administration.png",
      "alt": "Seal_of_the_United_States_Federal_Aviation_Administration"
    },
    {
      "id": 532,
      "title": "Department-of-Defense-seal-2",
      "source": "/assets/Department-of-Defense-seal-2.png",
      "alt": "Department-of-Defense-seal-2"
    },
    {
      "id": 531,
      "title": "Intelligence-Community-seal-2",
      "source": "/assets/Intelligence-Community-seal-2.png",
      "alt": "Intelligence-Community-seal-2"
    },
    {
      "id": 528,
      "title": "INSCOM_SEAL-2",
      "source": "/assets/INSCOM_SEAL-2-e1536587378930.jpg",
      "alt": "INSCOM_SEAL-2"
    },
    {
      "id": 509,
      "title": "884301598-1024x1024",
      "source": "/assets/884301598-1024x1024.jpg",
      "alt": "884301598-1024x1024"
    },
    {
      "id": 508,
      "title": "849234128-1024x1024",
      "source": "/assets/849234128-1024x1024-e1536339069389.jpg",
      "alt": "849234128-1024x1024"
    },
    {
      "id": 506,
      "title": "886646974-1024x1024",
      "source": "/assets/886646974-1024x1024.jpg",
      "alt": "886646974-1024x1024"
    },
    {
      "id": 484,
      "title": "logo-ITAR",
      "source": "/assets/logo-ITAR.png",
      "alt": "logo-ITAR"
    },
    {
      "id": 483,
      "title": "XZyX8mW9_400x400",
      "source": "/assets/XZyX8mW9_400x400.png",
      "alt": "AFCEA logo"
    },
    {
      "id": 482,
      "title": "(ISC)2 logo",
      "source": "/assets/ISC²_logo_vectorized.svg_.png",
      "alt": "(ISC)2 logo"
    },
    {
      "id": 481,
      "title": "infragard-logo",
      "source": "/assets/infragard-logo.jpg",
      "alt": "Infragard logo"
    },
    {
      "id": 480,
      "title": "images",
      "source": "/assets/images.jpg",
      "alt": "HTC logo"
    },
    {
      "id": 455,
      "title": "921054466-1024x1024",
      "source": "/assets/921054466-1024x1024.jpg",
      "alt": "921054466-1024x1024"
    },
    {
      "id": 453,
      "title": "506485418-1024x1024",
      "source": "/assets/506485418-1024x1024.jpg",
      "alt": "506485418-1024x1024"
    },
    {
      "id": 450,
      "title": "507021778-1024x1024",
      "source": "/assets/507021778-1024x1024.jpg",
      "alt": "507021778-1024x1024"
    },
    {
      "id": 446,
      "title": "639312500-1024x1024",
      "source": "/assets/639312500-1024x1024.jpg",
      "alt": "639312500-1024x1024"
    },
    {
      "id": 444,
      "title": "116779691-1024x1024",
      "source": "/assets/116779691-1024x1024.jpg",
      "alt": "116779691-1024x1024"
    },
    {
      "id": 441,
      "title": "852149362-1024x1024",
      "source": "/assets/852149362-1024x1024-e1534436515271.jpg",
      "alt": "852149362-1024x1024"
    },
    {
      "id": 439,
      "title": "508917664-1024x1024",
      "source": "/assets/508917664-1024x1024.jpg",
      "alt": "508917664-1024x1024"
    },
    {
      "id": 437,
      "title": "545123748-1024x1024",
      "source": "/assets/545123748-1024x1024.jpg",
      "alt": "545123748-1024x1024"
    },
    {
      "id": 435,
      "title": "525474436-1024x1024",
      "source": "/assets/525474436-1024x1024-e1534519842769.jpg",
      "alt": "525474436-1024x1024"
    },
    {
      "id": 430,
      "title": "832632796-1024x1024",
      "source": "/assets/832632796-1024x1024-e1534436063140.jpg",
      "alt": "832632796-1024x1024"
    },
    {
      "id": 428,
      "title": "anna-kolosyuk-551398-unsplash",
      "source": "/assets/anna-kolosyuk-551398-unsplash.jpg",
      "alt": "anna-kolosyuk-551398-unsplash"
    },
    {
      "id": 425,
      "title": "520791880-1024x1024",
      "source": "/assets/520791880-1024x1024.jpg",
      "alt": "520791880-1024x1024"
    },
    {
      "id": 422,
      "title": "888100376-1024x1024",
      "source": "/assets/888100376-1024x1024.jpg",
      "alt": "888100376-1024x1024"
    },
    {
      "id": 417,
      "title": "881634740-1024x1024",
      "source": "/assets/881634740-1024x1024.jpg",
      "alt": "881634740-1024x1024"
    },
    {
      "id": 415,
      "title": "singapore-river-255116_960_720",
      "source": "/assets/singapore-river-255116_960_720.jpg",
      "alt": "singapore-river-255116_960_720"
    },
    {
      "id": 413,
      "title": "624440402-1024x1024",
      "source": "/assets/624440402-1024x1024.jpg",
      "alt": "624440402-1024x1024"
    },
    {
      "id": 409,
      "title": "866364868-1024x1024",
      "source": "/assets/866364868-1024x1024.jpg",
      "alt": "866364868-1024x1024"
    },
    {
      "id": 405,
      "title": "842866300-1024x1024",
      "source": "/assets/842866300-1024x1024-e1534434183344.jpg",
      "alt": "842866300-1024x1024"
    },
    {
      "id": 393,
      "title": "Federal-Aviation-Administration-seal",
      "source": "/assets/Federal-Aviation-Administration-seal-e1536586697310.jpg",
      "alt": "Federal-Aviation-Administration-seal"
    },
    {
      "id": 392,
      "title": "Department-of-Defense-seal",
      "source": "/assets/Department-of-Defense-seal.png",
      "alt": "Department-of-Defense-seal"
    },
    {
      "id": 391,
      "title": "Intelligence-Community-seal",
      "source": "/assets/Intelligence-Community-seal.png",
      "alt": "Intelligence-Community-seal"
    },
    {
      "id": 390,
      "title": "INSCOM-seal",
      "source": "/assets/INSCOM-seal.png",
      "alt": "INSCOM-seal"
    },
    {
      "id": 365,
      "title": "Close of up table with equipment in conference room. 3D Rendering",
      "source": "/assets/649495828-crop.jpg",
      "alt": "Close of up table with equipment in conference room. 3D Rendering"
    },
    {
      "id": 340,
      "title": "afcea_400x400_k",
      "source": "/assets/afcea_400x400_k.png",
      "alt": "afcea_400x400_k"
    },
    {
      "id": 338,
      "title": "HTC-logo-K",
      "source": "/assets/HTC-logo-K.jpg",
      "alt": "HTC-logo-K"
    },
    {
      "id": 332,
      "title": "MGMA_State_logo_k",
      "source": "/assets/MGMA_State_logo_k.png",
      "alt": "MGMA"
    },
    {
      "id": 331,
      "title": "itar_logo_k",
      "source": "/assets/itar_logo_k.png",
      "alt": "ITAR Certified"
    },
    {
      "id": 330,
      "title": "infragard-logo_k",
      "source": "/assets/infragard-logo_k.jpg",
      "alt": "InfraGard (FBI)"
    },
    {
      "id": 328,
      "title": "(ISC)²_logo_k",
      "source": "/assets/ISC²_logo_k.png",
      "alt": "ISC2"
    },
    {
      "id": 247,
      "title": "secure",
      "source": "/assets/secure.png",
      "alt": "secure"
    }
  ]
};
